/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.12.1.0 (NJsonSchema v10.4.6.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class ApiAlert {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    get(getAll: boolean): Observable<GetAlertsResponse> {
        let url_ = this.baseUrl + "/api/alert/{getAll}";
        if (getAll === undefined || getAll === null)
            throw new Error("The parameter 'getAll' must be defined.");
        url_ = url_.replace("{getAll}", encodeURIComponent("" + getAll));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<GetAlertsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAlertsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetAlertsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAlertsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiAnimal {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    add(dier: Dier): Observable<AddAnimalResult> {
        let url_ = this.baseUrl + "/api/animal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dier);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(<any>response_);
                } catch (e) {
                    return <Observable<AddAnimalResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddAnimalResult>><any>_observableThrow(response_);
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<AddAnimalResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    importAnimals(date: Date): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/animal/{date}";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent(date ? "" + date.toJSON() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportAnimals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportAnimals(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processImportAnimals(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getAnimalsByBatch(id: number): Observable<Dier[]> {
        let url_ = this.baseUrl + "/api/animal/batch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnimalsByBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnimalsByBatch(<any>response_);
                } catch (e) {
                    return <Observable<Dier[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Dier[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnimalsByBatch(response: HttpResponseBase): Observable<Dier[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Dier.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiAuth {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    refreshToken(request: RefreshTokenRequest): Observable<RefreshTokenResponse> {
        let url_ = this.baseUrl + "/api/auth/refreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(<any>response_);
                } catch (e) {
                    return <Observable<RefreshTokenResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<RefreshTokenResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<RefreshTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    login(request: LoginRequest): Observable<LoginResponse> {
        let url_ = this.baseUrl + "/api/auth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(<any>response_);
                } catch (e) {
                    return <Observable<LoginResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoginResponse>><any>_observableThrow(response_);
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<LoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getPublicFeatureFlags(isTestEnvironment?: boolean | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/auth?";
        if (isTestEnvironment === null)
            throw new Error("The parameter 'isTestEnvironment' cannot be null.");
        else if (isTestEnvironment !== undefined)
            url_ += "isTestEnvironment=" + encodeURIComponent("" + isTestEnvironment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicFeatureFlags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicFeatureFlags(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPublicFeatureFlags(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiBatch {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getAllBatches(): Observable<Batch[]> {
        let url_ = this.baseUrl + "/api/batch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBatches(<any>response_);
                } catch (e) {
                    return <Observable<Batch[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Batch[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBatches(response: HttpResponseBase): Observable<Batch[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Batch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    updateBatch(batch: Batch): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batch);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBatch(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateBatch(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getActiveBatches(): Observable<Batch[]> {
        let url_ = this.baseUrl + "/api/batch/active";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveBatches(<any>response_);
                } catch (e) {
                    return <Observable<Batch[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Batch[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveBatches(response: HttpResponseBase): Observable<Batch[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Batch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getBatchById(id: number): Observable<BatchInfoDto> {
        let url_ = this.baseUrl + "/api/batch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchById(<any>response_);
                } catch (e) {
                    return <Observable<BatchInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BatchInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBatchById(response: HttpResponseBase): Observable<BatchInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getSoorten(): Observable<DierSoort[]> {
        let url_ = this.baseUrl + "/api/batch/diersoort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSoorten(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSoorten(<any>response_);
                } catch (e) {
                    return <Observable<DierSoort[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DierSoort[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSoorten(response: HttpResponseBase): Observable<DierSoort[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DierSoort.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getRassen(): Observable<Ras[]> {
        let url_ = this.baseUrl + "/api/batch/ras";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRassen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRassen(<any>response_);
                } catch (e) {
                    return <Observable<Ras[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Ras[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRassen(response: HttpResponseBase): Observable<Ras[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ras.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getCollectedBatchInformation(number: string | null, productId?: number | undefined): Observable<GetCollectedBatchInformationResult> {
        let url_ = this.baseUrl + "/api/batch/collected/{number}?";
        if (number === undefined || number === null)
            throw new Error("The parameter 'number' must be defined.");
        url_ = url_.replace("{number}", encodeURIComponent("" + number));
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCollectedBatchInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCollectedBatchInformation(<any>response_);
                } catch (e) {
                    return <Observable<GetCollectedBatchInformationResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCollectedBatchInformationResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetCollectedBatchInformation(response: HttpResponseBase): Observable<GetCollectedBatchInformationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCollectedBatchInformationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiBerichten {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getMessageForLogin(): Observable<Bericht> {
        let url_ = this.baseUrl + "/api/berichten";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMessageForLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMessageForLogin(<any>response_);
                } catch (e) {
                    return <Observable<Bericht>><any>_observableThrow(e);
                }
            } else
                return <Observable<Bericht>><any>_observableThrow(response_);
        }));
    }

    protected processGetMessageForLogin(response: HttpResponseBase): Observable<Bericht> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bericht.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiBtw {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    get(): Observable<Btw[]> {
        let url_ = this.baseUrl + "/api/btw";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<Btw[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Btw[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Btw[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Btw.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiCalculation {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    calculateShoppingCart(request: CalculateOrderCostsRequest): Observable<CalculateOrderCostsResponse> {
        let url_ = this.baseUrl + "/api/calculation/orderregels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateShoppingCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateShoppingCart(<any>response_);
                } catch (e) {
                    return <Observable<CalculateOrderCostsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalculateOrderCostsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCalculateShoppingCart(response: HttpResponseBase): Observable<CalculateOrderCostsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateOrderCostsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiCompany {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    get(): Observable<Bedrijfsgegevens> {
        let url_ = this.baseUrl + "/api/company";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<Bedrijfsgegevens>><any>_observableThrow(e);
                }
            } else
                return <Observable<Bedrijfsgegevens>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Bedrijfsgegevens> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bedrijfsgegevens.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    save(gegevens: Bedrijfsgegevens): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gegevens);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiDashboard {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getTopOfProducts(): Observable<PiChartDto> {
        let url_ = this.baseUrl + "/api/dashboard/producten";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopOfProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopOfProducts(<any>response_);
                } catch (e) {
                    return <Observable<PiChartDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PiChartDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTopOfProducts(response: HttpResponseBase): Observable<PiChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PiChartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getRevenueData(year: number): Observable<GraphDto> {
        let url_ = this.baseUrl + "/api/dashboard/omzet/{year}";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRevenueData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRevenueData(<any>response_);
                } catch (e) {
                    return <Observable<GraphDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GraphDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRevenueData(response: HttpResponseBase): Observable<GraphDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GraphDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getTopOfCustumers(): Observable<PiChartDto> {
        let url_ = this.baseUrl + "/api/dashboard/klanten";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopOfCustumers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopOfCustumers(<any>response_);
                } catch (e) {
                    return <Observable<PiChartDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PiChartDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTopOfCustumers(response: HttpResponseBase): Observable<PiChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PiChartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getOrderOfWeek(): Observable<GraphDto> {
        let url_ = this.baseUrl + "/api/dashboard/orders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderOfWeek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderOfWeek(<any>response_);
                } catch (e) {
                    return <Observable<GraphDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GraphDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderOfWeek(response: HttpResponseBase): Observable<GraphDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GraphDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    dieren(): Observable<GraphDto> {
        let url_ = this.baseUrl + "/api/dashboard/dieren";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDieren(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDieren(<any>response_);
                } catch (e) {
                    return <Observable<GraphDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GraphDto>><any>_observableThrow(response_);
        }));
    }

    protected processDieren(response: HttpResponseBase): Observable<GraphDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GraphDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getOustandingInvoices(): Observable<GetOustandingInvoicesResponse> {
        let url_ = this.baseUrl + "/api/dashboard/outstanding";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOustandingInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOustandingInvoices(<any>response_);
                } catch (e) {
                    return <Observable<GetOustandingInvoicesResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOustandingInvoicesResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetOustandingInvoices(response: HttpResponseBase): Observable<GetOustandingInvoicesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOustandingInvoicesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getActions(): Observable<GetActionsResponse> {
        let url_ = this.baseUrl + "/api/dashboard/actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActions(<any>response_);
                } catch (e) {
                    return <Observable<GetActionsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetActionsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetActions(response: HttpResponseBase): Observable<GetActionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetActionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getTotalResult(): Observable<GetTotalResultResponse> {
        let url_ = this.baseUrl + "/api/dashboard/result";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalResult(<any>response_);
                } catch (e) {
                    return <Observable<GetTotalResultResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTotalResultResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetTotalResult(response: HttpResponseBase): Observable<GetTotalResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTotalResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getShipments(shipmentType: ShipmentType): Observable<GetShipmentStatusRespone> {
        let url_ = this.baseUrl + "/api/dashboard/shipment/{shipmentType}";
        if (shipmentType === undefined || shipmentType === null)
            throw new Error("The parameter 'shipmentType' must be defined.");
        url_ = url_.replace("{shipmentType}", encodeURIComponent("" + shipmentType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShipments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShipments(<any>response_);
                } catch (e) {
                    return <Observable<GetShipmentStatusRespone>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetShipmentStatusRespone>><any>_observableThrow(response_);
        }));
    }

    protected processGetShipments(response: HttpResponseBase): Observable<GetShipmentStatusRespone> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShipmentStatusRespone.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiEenheid {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    get(): Observable<Eenheid[]> {
        let url_ = this.baseUrl + "/api/eenheid";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<Eenheid[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Eenheid[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Eenheid[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Eenheid.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiFarmer {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getAll(): Observable<Boer[]> {
        let url_ = this.baseUrl + "/api/farmers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<Boer[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Boer[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Boer[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Boer.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    post(value: Boer): Observable<void> {
        let url_ = this.baseUrl + "/api/farmers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    get(id: number): Observable<Boer> {
        let url_ = this.baseUrl + "/api/farmers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<Boer>><any>_observableThrow(e);
                }
            } else
                return <Observable<Boer>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Boer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Boer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    put(id: number, value: Boer): Observable<void> {
        let url_ = this.baseUrl + "/api/farmers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/farmers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getByExternalId(id: number): Observable<Boer> {
        let url_ = this.baseUrl + "/api/farmers/external/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByExternalId(<any>response_);
                } catch (e) {
                    return <Observable<Boer>><any>_observableThrow(e);
                }
            } else
                return <Observable<Boer>><any>_observableThrow(response_);
        }));
    }

    protected processGetByExternalId(response: HttpResponseBase): Observable<Boer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Boer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getAnimalCountGraph(id: number): Observable<GraphDto> {
        let url_ = this.baseUrl + "/api/farmers/animalCount/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnimalCountGraph(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnimalCountGraph(<any>response_);
                } catch (e) {
                    return <Observable<GraphDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GraphDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnimalCountGraph(response: HttpResponseBase): Observable<GraphDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GraphDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiFinance {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getWeekRevenue(week?: number | undefined): Observable<GetWeekRevenueResponse> {
        let url_ = this.baseUrl + "/api/finance/week?";
        if (week === null)
            throw new Error("The parameter 'week' cannot be null.");
        else if (week !== undefined)
            url_ += "week=" + encodeURIComponent("" + week) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWeekRevenue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeekRevenue(<any>response_);
                } catch (e) {
                    return <Observable<GetWeekRevenueResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetWeekRevenueResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetWeekRevenue(response: HttpResponseBase): Observable<GetWeekRevenueResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWeekRevenueResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getMonthRevenue(month?: number | undefined): Observable<GetMonthRevenueResponse> {
        let url_ = this.baseUrl + "/api/finance/month?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthRevenue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthRevenue(<any>response_);
                } catch (e) {
                    return <Observable<GetMonthRevenueResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMonthRevenueResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetMonthRevenue(response: HttpResponseBase): Observable<GetMonthRevenueResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMonthRevenueResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiGoogle {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getBusinessHours(): Observable<GetBusinessHoursRespone> {
        let url_ = this.baseUrl + "/api/google-business";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessHours(<any>response_);
                } catch (e) {
                    return <Observable<GetBusinessHoursRespone>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBusinessHoursRespone>><any>_observableThrow(response_);
        }));
    }

    protected processGetBusinessHours(response: HttpResponseBase): Observable<GetBusinessHoursRespone> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBusinessHoursRespone.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiGrootboek {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    get(): Observable<Grootboek[]> {
        let url_ = this.baseUrl + "/api/grootboek";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<Grootboek[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Grootboek[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Grootboek[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Grootboek.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    add(grootboek: Grootboek): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/grootboek";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(grootboek);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getFormSnelStart(): Observable<SnelStartGrootboekDto[]> {
        let url_ = this.baseUrl + "/api/grootboek/formSnelStart";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormSnelStart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormSnelStart(<any>response_);
                } catch (e) {
                    return <Observable<SnelStartGrootboekDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SnelStartGrootboekDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFormSnelStart(response: HttpResponseBase): Observable<SnelStartGrootboekDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SnelStartGrootboekDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiInvoice {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    get(): Observable<Pakbon[]> {
        let url_ = this.baseUrl + "/api/invoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<Pakbon[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Pakbon[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Pakbon[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Pakbon.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    createInvoices(pakbonnen: number[], invoiceDate?: Date | undefined): Observable<InvoiceStatusResponse[]> {
        let url_ = this.baseUrl + "/api/invoices?";
        if (invoiceDate === null)
            throw new Error("The parameter 'invoiceDate' cannot be null.");
        else if (invoiceDate !== undefined)
            url_ += "invoiceDate=" + encodeURIComponent(invoiceDate ? "" + invoiceDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pakbonnen);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoices(<any>response_);
                } catch (e) {
                    return <Observable<InvoiceStatusResponse[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvoiceStatusResponse[]>><any>_observableThrow(response_);
        }));
    }

    protected processCreateInvoices(response: HttpResponseBase): Observable<InvoiceStatusResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceStatusResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getAllInvoicesForOrderSite(): Observable<Factuur[]> {
        let url_ = this.baseUrl + "/api/invoices/ordersite";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInvoicesForOrderSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInvoicesForOrderSite(<any>response_);
                } catch (e) {
                    return <Observable<Factuur[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Factuur[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllInvoicesForOrderSite(response: HttpResponseBase): Observable<Factuur[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Factuur.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    returnPakbonArchief(request: PakbonArchiefDto): Observable<Factuur[]> {
        let url_ = this.baseUrl + "/api/invoices/archief";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnPakbonArchief(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnPakbonArchief(<any>response_);
                } catch (e) {
                    return <Observable<Factuur[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Factuur[]>><any>_observableThrow(response_);
        }));
    }

    protected processReturnPakbonArchief(response: HttpResponseBase): Observable<Factuur[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Factuur.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    mailInvoice(invoiceId: number): Observable<InvoiceMailResponse> {
        let url_ = this.baseUrl + "/api/invoices/Mail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoiceId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMailInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMailInvoice(<any>response_);
                } catch (e) {
                    return <Observable<InvoiceMailResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvoiceMailResponse>><any>_observableThrow(response_);
        }));
    }

    protected processMailInvoice(response: HttpResponseBase): Observable<InvoiceMailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceMailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getPdfInvoiceById(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/invoices/pdf/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfInvoiceById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfInvoiceById(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPdfInvoiceById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    createExport(invoices: Factuur[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/invoices/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoices);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExport(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreateExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    uploadToSnelStart(invoiceId: number): Observable<PushToSnelStartResponse> {
        let url_ = this.baseUrl + "/api/invoices/push";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoiceId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadToSnelStart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadToSnelStart(<any>response_);
                } catch (e) {
                    return <Observable<PushToSnelStartResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PushToSnelStartResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUploadToSnelStart(response: HttpResponseBase): Observable<PushToSnelStartResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PushToSnelStartResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getInvoiceHtmlPreviewForCustomer(invoiceId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/invoices/pdf/customer/preview/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceHtmlPreviewForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceHtmlPreviewForCustomer(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetInvoiceHtmlPreviewForCustomer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getInvoiceHtmlPreview(invoiceId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/invoices/pdf/preview/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceHtmlPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceHtmlPreview(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetInvoiceHtmlPreview(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getOutstandingInvoices(): Observable<Factuur[]> {
        let url_ = this.baseUrl + "/api/invoices/outstanding";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutstandingInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutstandingInvoices(<any>response_);
                } catch (e) {
                    return <Observable<Factuur[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Factuur[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOutstandingInvoices(response: HttpResponseBase): Observable<Factuur[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Factuur.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    resentOutstandingInvoices(request: ResendOutstandingInvoicesRequest): Observable<InvoiceMailResponse[]> {
        let url_ = this.baseUrl + "/api/invoices/outstanding/mail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResentOutstandingInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResentOutstandingInvoices(<any>response_);
                } catch (e) {
                    return <Observable<InvoiceMailResponse[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvoiceMailResponse[]>><any>_observableThrow(response_);
        }));
    }

    protected processResentOutstandingInvoices(response: HttpResponseBase): Observable<InvoiceMailResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceMailResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getInvoiceStylePriview(): Observable<string> {
        let url_ = this.baseUrl + "/api/invoices/pdf/preview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceStylePriview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceStylePriview(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetInvoiceStylePriview(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiKlant {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getAll(): Observable<Klant[]> {
        let url_ = this.baseUrl + "/api/klanten";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<Klant[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Klant[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Klant[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Klant.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    post(value: Klant): Observable<void> {
        let url_ = this.baseUrl + "/api/klanten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    put(value: Klant): Observable<Klant> {
        let url_ = this.baseUrl + "/api/klanten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(<any>response_);
                } catch (e) {
                    return <Observable<Klant>><any>_observableThrow(e);
                }
            } else
                return <Observable<Klant>><any>_observableThrow(response_);
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<Klant> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Klant.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    get(id: number): Observable<Klant> {
        let url_ = this.baseUrl + "/api/klanten/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<Klant>><any>_observableThrow(e);
                }
            } else
                return <Observable<Klant>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Klant> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Klant.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/klanten/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    requestBusinessAccount(request: RegisterBusinessRelationRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/klanten/bussines/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestBusinessAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestBusinessAccount(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRequestBusinessAccount(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getRevenue(id: number): Observable<GraphDto> {
        let url_ = this.baseUrl + "/api/klanten/omzet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRevenue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRevenue(<any>response_);
                } catch (e) {
                    return <Observable<GraphDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GraphDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRevenue(response: HttpResponseBase): Observable<GraphDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GraphDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getTopOfProducts(id: number): Observable<PiChartDto> {
        let url_ = this.baseUrl + "/api/klanten/product/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopOfProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopOfProducts(<any>response_);
                } catch (e) {
                    return <Observable<PiChartDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PiChartDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTopOfProducts(response: HttpResponseBase): Observable<PiChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PiChartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getSnelStartKlanten(search: string | null): Observable<SnelStartCustomerSearchResponse> {
        let url_ = this.baseUrl + "/api/klanten/snelstart/{search}";
        if (search === undefined || search === null)
            throw new Error("The parameter 'search' must be defined.");
        url_ = url_.replace("{search}", encodeURIComponent("" + search));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSnelStartKlanten(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSnelStartKlanten(<any>response_);
                } catch (e) {
                    return <Observable<SnelStartCustomerSearchResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SnelStartCustomerSearchResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetSnelStartKlanten(response: HttpResponseBase): Observable<SnelStartCustomerSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SnelStartCustomerSearchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getMailstatusByCustomer(id: number): Observable<GetMailStatusByCustomerResponse> {
        let url_ = this.baseUrl + "/api/klanten/mailStatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailstatusByCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailstatusByCustomer(<any>response_);
                } catch (e) {
                    return <Observable<GetMailStatusByCustomerResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMailStatusByCustomerResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetMailstatusByCustomer(response: HttpResponseBase): Observable<GetMailStatusByCustomerResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMailStatusByCustomerResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    migrate(): Observable<void> {
        let url_ = this.baseUrl + "/api/klanten/migration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMigrate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMigrate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMigrate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiLogger {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    logError(logging: LoggingModel): Observable<void> {
        let url_ = this.baseUrl + "/api/logger";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logging);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogError(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogError(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLogError(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiOrder {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getAll(): Observable<Order[]> {
        let url_ = this.baseUrl + "/api/orders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<Order[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Order[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Order[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Order.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    post(request: CreateOrderRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    get(id: number): Observable<Order> {
        let url_ = this.baseUrl + "/api/orders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<Order>><any>_observableThrow(e);
                }
            } else
                return <Observable<Order>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Order> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Order.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    delete(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/orders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getByCustomer(id?: number | undefined): Observable<Order[]> {
        let url_ = this.baseUrl + "/api/orders/archief?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCustomer(<any>response_);
                } catch (e) {
                    return <Observable<Order[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Order[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetByCustomer(response: HttpResponseBase): Observable<Order[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Order.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiOrderList {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    get(id: number): Observable<Bestellijst> {
        let url_ = this.baseUrl + "/api/orderLists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<Bestellijst>><any>_observableThrow(e);
                }
            } else
                return <Observable<Bestellijst>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Bestellijst> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bestellijst.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    post(orderList: Bestellijst): Observable<Bestellijst> {
        let url_ = this.baseUrl + "/api/orderLists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<Bestellijst>><any>_observableThrow(e);
                }
            } else
                return <Observable<Bestellijst>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<Bestellijst> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bestellijst.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    addProductToList(request: AddProductToList): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/orderLists/regel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProductToList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProductToList(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddProductToList(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiPakbon {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getAll(): Observable<Pakbon[]> {
        let url_ = this.baseUrl + "/api/pakbonnen";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<Pakbon[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Pakbon[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Pakbon[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Pakbon.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    post(value: Pakbon): Observable<Pakbon> {
        let url_ = this.baseUrl + "/api/pakbonnen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<Pakbon>><any>_observableThrow(e);
                }
            } else
                return <Observable<Pakbon>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<Pakbon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Pakbon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    put(value: Pakbon): Observable<void> {
        let url_ = this.baseUrl + "/api/pakbonnen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    delete(regels: PakbonRegel[]): Observable<void> {
        let url_ = this.baseUrl + "/api/pakbonnen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(regels);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getAllToday(): Observable<Pakbon[]> {
        let url_ = this.baseUrl + "/api/pakbonnen/today";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllToday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllToday(<any>response_);
                } catch (e) {
                    return <Observable<Pakbon[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Pakbon[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllToday(response: HttpResponseBase): Observable<Pakbon[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Pakbon.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getUnfinished(): Observable<Pakbon[]> {
        let url_ = this.baseUrl + "/api/pakbonnen/unfinished";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnfinished(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnfinished(<any>response_);
                } catch (e) {
                    return <Observable<Pakbon[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Pakbon[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnfinished(response: HttpResponseBase): Observable<Pakbon[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Pakbon.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getById(id: number): Observable<Pakbon> {
        let url_ = this.baseUrl + "/api/pakbonnen/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<Pakbon>><any>_observableThrow(e);
                }
            } else
                return <Observable<Pakbon>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<Pakbon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Pakbon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getAllPackingslipsForOrderSite(): Observable<Pakbon[]> {
        let url_ = this.baseUrl + "/api/pakbonnen/ordersite";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPackingslipsForOrderSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPackingslipsForOrderSite(<any>response_);
                } catch (e) {
                    return <Observable<Pakbon[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Pakbon[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPackingslipsForOrderSite(response: HttpResponseBase): Observable<Pakbon[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Pakbon.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getPdfPackingslipById(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/pakbonnen/pdf/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfPackingslipById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfPackingslipById(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPdfPackingslipById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getPdfHtmlPreviewById(id: number): Observable<string> {
        let url_ = this.baseUrl + "/api/pakbonnen/pdf/preview/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfHtmlPreviewById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfHtmlPreviewById(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetPdfHtmlPreviewById(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    savePackingSlipFormOrder(value: Order): Observable<Pakbon> {
        let url_ = this.baseUrl + "/api/pakbonnen/fromOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePackingSlipFormOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePackingSlipFormOrder(<any>response_);
                } catch (e) {
                    return <Observable<Pakbon>><any>_observableThrow(e);
                }
            } else
                return <Observable<Pakbon>><any>_observableThrow(response_);
        }));
    }

    protected processSavePackingSlipFormOrder(response: HttpResponseBase): Observable<Pakbon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Pakbon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    returnPakbonArchief(value: PakbonArchiefDto): Observable<Pakbon[]> {
        let url_ = this.baseUrl + "/api/pakbonnen/archief";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnPakbonArchief(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnPakbonArchief(<any>response_);
                } catch (e) {
                    return <Observable<Pakbon[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Pakbon[]>><any>_observableThrow(response_);
        }));
    }

    protected processReturnPakbonArchief(response: HttpResponseBase): Observable<Pakbon[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Pakbon.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    mailPackingslip(value: Pakbon): Observable<PackingslipMailResponse> {
        let url_ = this.baseUrl + "/api/pakbonnen/Mail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMailPackingslip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMailPackingslip(<any>response_);
                } catch (e) {
                    return <Observable<PackingslipMailResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PackingslipMailResponse>><any>_observableThrow(response_);
        }));
    }

    protected processMailPackingslip(response: HttpResponseBase): Observable<PackingslipMailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackingslipMailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiPayment {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    /**
     * @deprecated
     */
    creatObseletePayment(tenantId: string, invoiceId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/payment/{tenantId}/{invoiceId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatObseletePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatObseletePayment(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreatObseletePayment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    creatPayment(invoiceId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/payment/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatPayment(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreatPayment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    /**
     * @deprecated
     */
    redirectToStatusPageObselete(tenantId: string, invoiceId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/payment/redirect/{tenantId}/{invoiceId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRedirectToStatusPageObselete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRedirectToStatusPageObselete(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRedirectToStatusPageObselete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    redirectToStatusPage(invoiceId: string, tenantId?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/payment/redirect/{invoiceId}?";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRedirectToStatusPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRedirectToStatusPage(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRedirectToStatusPage(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    paymentWebhookObeselete(tenantId: string, id?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/payment/{tenantId}/webhook";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("id", id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentWebhookObeselete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentWebhookObeselete(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processPaymentWebhookObeselete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    paymentWebhook(id?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/payment/webhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("id", id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentWebhook(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processPaymentWebhook(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiPrint {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    printPakbonOnEpson(pakbon: Pakbon): Observable<string> {
        let url_ = this.baseUrl + "/api/printing/pakbon";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pakbon);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintPakbonOnEpson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintPakbonOnEpson(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPrintPakbonOnEpson(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    printLabel(printCommand: PrintLabelViewModel): Observable<string> {
        let url_ = this.baseUrl + "/api/printing/label";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(printCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintLabel(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPrintLabel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    printLabelWithoutStock(printCommand: PrintLabelViewModel): Observable<string> {
        let url_ = this.baseUrl + "/api/printing/label/tht";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(printCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintLabelWithoutStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintLabelWithoutStock(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPrintLabelWithoutStock(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiProduct {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getAll(): Observable<Product[]> {
        let url_ = this.baseUrl + "/api/product";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<Product[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Product[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Product[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    post(value: Product): Observable<void> {
        let url_ = this.baseUrl + "/api/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getAllWithoutReferences(): Observable<Product[]> {
        let url_ = this.baseUrl + "/api/product/noReferences";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithoutReferences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithoutReferences(<any>response_);
                } catch (e) {
                    return <Observable<Product[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Product[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWithoutReferences(response: HttpResponseBase): Observable<Product[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getAllWithMutations(): Observable<Product[]> {
        let url_ = this.baseUrl + "/api/product/wihtMutations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithMutations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithMutations(<any>response_);
                } catch (e) {
                    return <Observable<Product[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Product[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWithMutations(response: HttpResponseBase): Observable<Product[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getForSite(): Observable<Product[]> {
        let url_ = this.baseUrl + "/api/product/ordersite";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForSite(<any>response_);
                } catch (e) {
                    return <Observable<Product[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Product[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetForSite(response: HttpResponseBase): Observable<Product[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getForHorecaSite(): Observable<Product[]> {
        let url_ = this.baseUrl + "/api/product/horecasite";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForHorecaSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForHorecaSite(<any>response_);
                } catch (e) {
                    return <Observable<Product[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Product[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetForHorecaSite(response: HttpResponseBase): Observable<Product[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    get(id: number): Observable<Product> {
        let url_ = this.baseUrl + "/api/product/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<Product>><any>_observableThrow(e);
                }
            } else
                return <Observable<Product>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Product> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Product.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    put(id: number, value: Product): Observable<void> {
        let url_ = this.baseUrl + "/api/product/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/product/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getLabel(products: Product[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/product/labels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(products);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabel(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetLabel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getPdfPriceList(request: GetPriceListRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/product/price-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfPriceList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfPriceList(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPdfPriceList(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    upload(productId?: number | undefined, image?: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/product/image?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (image !== null && image !== undefined)
            content_.append("image", image.data, image.fileName ? image.fileName : "image");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    deleteImage(productId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/product/image?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteImage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getMutatieByProduct(id: number): Observable<Product[]> {
        let url_ = this.baseUrl + "/api/product/mutatie/{id}/product";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMutatieByProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMutatieByProduct(<any>response_);
                } catch (e) {
                    return <Observable<Product[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Product[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMutatieByProduct(response: HttpResponseBase): Observable<Product[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    saveMutatie(mutatie: ProductMutatie): Observable<void> {
        let url_ = this.baseUrl + "/api/product/mutatie";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mutatie);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMutatie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMutatie(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSaveMutatie(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    updateMutatie(mutatie: ProductMutatie): Observable<void> {
        let url_ = this.baseUrl + "/api/product/mutatie";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mutatie);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMutatie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMutatie(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateMutatie(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    hasProductMutations(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/product/mutatie/{id}/hasMutations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasProductMutations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasProductMutations(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processHasProductMutations(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getWeegsysteemProductenByGroup(id: number): Observable<Product[]> {
        let url_ = this.baseUrl + "/api/product/weegsysteem/groepen/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWeegsysteemProductenByGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeegsysteemProductenByGroup(<any>response_);
                } catch (e) {
                    return <Observable<Product[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Product[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWeegsysteemProductenByGroup(response: HttpResponseBase): Observable<Product[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getProductChilderen(id: number): Observable<Product[]> {
        let url_ = this.baseUrl + "/api/product/Childeren/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductChilderen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductChilderen(<any>response_);
                } catch (e) {
                    return <Observable<Product[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Product[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductChilderen(response: HttpResponseBase): Observable<Product[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiProductGroup {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    get(): Observable<ProductGroep[]> {
        let url_ = this.baseUrl + "/api/productgroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ProductGroep[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductGroep[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductGroep[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductGroep.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiPush {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    subcribeNotification(model: PushSubscriptionModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/push";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubcribeNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubcribeNotification(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSubcribeNotification(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    pushMessage(endpoint: string | null): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/push/{endpoint}";
        if (endpoint === undefined || endpoint === null)
            throw new Error("The parameter 'endpoint' must be defined.");
        url_ = url_.replace("{endpoint}", encodeURIComponent("" + endpoint));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushMessage(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processPushMessage(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    unSubscribe(request: UnsubscribeDeviceRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/push/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnSubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnSubscribe(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUnSubscribe(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiReport {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getOmzetReport(model: ReportSelectieDto): Observable<OmzetResultDto> {
        let url_ = this.baseUrl + "/api/report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOmzetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOmzetReport(<any>response_);
                } catch (e) {
                    return <Observable<OmzetResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OmzetResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOmzetReport(response: HttpResponseBase): Observable<OmzetResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OmzetResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiScanning {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getDierManual(model: AddManualAnimalDto): Observable<ScanningBatchResultDto> {
        let url_ = this.baseUrl + "/api/scanning/manual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDierManual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDierManual(<any>response_);
                } catch (e) {
                    return <Observable<ScanningBatchResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ScanningBatchResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDierManual(response: HttpResponseBase): Observable<ScanningBatchResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScanningBatchResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiSettings {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    get(): Observable<Settings> {
        let url_ = this.baseUrl + "/api/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<Settings>><any>_observableThrow(e);
                }
            } else
                return <Observable<Settings>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Settings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Settings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    update(settings: Settings): Observable<void> {
        let url_ = this.baseUrl + "/api/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getMailStatus(request: GetMailHistoryRequest): Observable<GetMailHistoryResponse> {
        let url_ = this.baseUrl + "/api/settings/mailstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailStatus(<any>response_);
                } catch (e) {
                    return <Observable<GetMailHistoryResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMailHistoryResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetMailStatus(response: HttpResponseBase): Observable<GetMailHistoryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMailHistoryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    update2(gebruiker: Gebruiker): Observable<void> {
        let url_ = this.baseUrl + "/api/settings/portalUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gebruiker);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate2(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    convertImageToBase64(file?: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/settings/getBaseString";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvertImageToBase64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertImageToBase64(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processConvertImageToBase64(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiShippingLabel {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getAllOutstandingShipments(): Observable<GroupedVerzendLabel[]> {
        let url_ = this.baseUrl + "/api/shippinglabel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOutstandingShipments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOutstandingShipments(<any>response_);
                } catch (e) {
                    return <Observable<GroupedVerzendLabel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GroupedVerzendLabel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllOutstandingShipments(response: HttpResponseBase): Observable<GroupedVerzendLabel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupedVerzendLabel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getByBarcode(barcode: string | null): Observable<GroupedVerzendLabel> {
        let url_ = this.baseUrl + "/api/shippinglabel/{barcode}";
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByBarcode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByBarcode(<any>response_);
                } catch (e) {
                    return <Observable<GroupedVerzendLabel>><any>_observableThrow(e);
                }
            } else
                return <Observable<GroupedVerzendLabel>><any>_observableThrow(response_);
        }));
    }

    protected processGetByBarcode(response: HttpResponseBase): Observable<GroupedVerzendLabel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupedVerzendLabel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    delete(barcode: string | null): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/shippinglabel/{barcode}";
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getRecentDeliveredShipments(): Observable<GroupedVerzendLabel[]> {
        let url_ = this.baseUrl + "/api/shippinglabel/Recent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentDeliveredShipments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentDeliveredShipments(<any>response_);
                } catch (e) {
                    return <Observable<GroupedVerzendLabel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GroupedVerzendLabel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecentDeliveredShipments(response: HttpResponseBase): Observable<GroupedVerzendLabel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupedVerzendLabel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getStatusByBarcode(barcode: string | null): Observable<PostnlBarcodeShipmentStatusResponse> {
        let url_ = this.baseUrl + "/api/shippinglabel/barcode/{barcode}";
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusByBarcode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusByBarcode(<any>response_);
                } catch (e) {
                    return <Observable<PostnlBarcodeShipmentStatusResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PostnlBarcodeShipmentStatusResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetStatusByBarcode(response: HttpResponseBase): Observable<PostnlBarcodeShipmentStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PostnlBarcodeShipmentStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    createPostNlShipment(request: CreatePostNlShipmentLableRequest): Observable<CreatePostNlShipmentLableResponse> {
        let url_ = this.baseUrl + "/api/shippinglabel/create/postnl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePostNlShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePostNlShipment(<any>response_);
                } catch (e) {
                    return <Observable<CreatePostNlShipmentLableResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreatePostNlShipmentLableResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePostNlShipment(response: HttpResponseBase): Observable<CreatePostNlShipmentLableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePostNlShipmentLableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    createMyParcelShipment(request: CreateMyParcelShipmentLabelRequest): Observable<CreateMyParcelShipmentLabelResponse> {
        let url_ = this.baseUrl + "/api/shippinglabel/create/myparcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMyParcelShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMyParcelShipment(<any>response_);
                } catch (e) {
                    return <Observable<CreateMyParcelShipmentLabelResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateMyParcelShipmentLabelResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMyParcelShipment(response: HttpResponseBase): Observable<CreateMyParcelShipmentLabelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateMyParcelShipmentLabelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    downloadMyparcelLabel(shipmentId: number): Observable<GetMyParcelLabelResponse> {
        let url_ = this.baseUrl + "/api/shippinglabel/download/myparcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shipmentId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadMyparcelLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadMyparcelLabel(<any>response_);
                } catch (e) {
                    return <Observable<GetMyParcelLabelResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMyParcelLabelResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadMyparcelLabel(response: HttpResponseBase): Observable<GetMyParcelLabelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyParcelLabelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    uploadBulkAddress(file?: FileParameter | null | undefined): Observable<ImportBuldAddressResponse> {
        let url_ = this.baseUrl + "/api/shippinglabel/bulk/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBulkAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBulkAddress(<any>response_);
                } catch (e) {
                    return <Observable<ImportBuldAddressResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportBuldAddressResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUploadBulkAddress(response: HttpResponseBase): Observable<ImportBuldAddressResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportBuldAddressResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    createBulkShipments(request: CreateBulkShipmentsRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/shippinglabel/bulk/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBulkShipments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBulkShipments(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateBulkShipments(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getBulks(): Observable<VerzendBulk[]> {
        let url_ = this.baseUrl + "/api/shippinglabel/bulk";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulks(<any>response_);
                } catch (e) {
                    return <Observable<VerzendBulk[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<VerzendBulk[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBulks(response: HttpResponseBase): Observable<VerzendBulk[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VerzendBulk.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getBulkById(id: number): Observable<VerzendBulk> {
        let url_ = this.baseUrl + "/api/shippinglabel/bulk/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkById(<any>response_);
                } catch (e) {
                    return <Observable<VerzendBulk>><any>_observableThrow(e);
                }
            } else
                return <Observable<VerzendBulk>><any>_observableThrow(response_);
        }));
    }

    protected processGetBulkById(response: HttpResponseBase): Observable<VerzendBulk> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerzendBulk.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiStock {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getAllActive(): Observable<Voorraad[]> {
        let url_ = this.baseUrl + "/api/stock";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActive(<any>response_);
                } catch (e) {
                    return <Observable<Voorraad[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Voorraad[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllActive(response: HttpResponseBase): Observable<Voorraad[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Voorraad.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    addStockToPackingslipRow(request: PackingSlipStockDto): Observable<void> {
        let url_ = this.baseUrl + "/api/stock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddStockToPackingslipRow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddStockToPackingslipRow(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddStockToPackingslipRow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getByProduct(id: number): Observable<Voorraad[]> {
        let url_ = this.baseUrl + "/api/stock/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProduct(<any>response_);
                } catch (e) {
                    return <Observable<Voorraad[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Voorraad[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetByProduct(response: HttpResponseBase): Observable<Voorraad[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Voorraad.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getStockByBatch(id: number): Observable<Voorraad[]> {
        let url_ = this.baseUrl + "/api/stock/batch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockByBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockByBatch(<any>response_);
                } catch (e) {
                    return <Observable<Voorraad[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Voorraad[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetStockByBatch(response: HttpResponseBase): Observable<Voorraad[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Voorraad.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getByStockId(id: number): Observable<Voorraad> {
        let url_ = this.baseUrl + "/api/stock/track/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByStockId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByStockId(<any>response_);
                } catch (e) {
                    return <Observable<Voorraad>><any>_observableThrow(e);
                }
            } else
                return <Observable<Voorraad>><any>_observableThrow(response_);
        }));
    }

    protected processGetByStockId(response: HttpResponseBase): Observable<Voorraad> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Voorraad.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getBatches(): Observable<BatchInfoDto[]> {
        let url_ = this.baseUrl + "/api/stock/batches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatches(<any>response_);
                } catch (e) {
                    return <Observable<BatchInfoDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BatchInfoDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBatches(response: HttpResponseBase): Observable<BatchInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BatchInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    addToStock(command: AddToStockDto): Observable<string> {
        let url_ = this.baseUrl + "/api/stock/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddToStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddToStock(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAddToStock(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    removeStockFromPackingslipRow(request: PakbonRegel): Observable<void> {
        let url_ = this.baseUrl + "/api/stock/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveStockFromPackingslipRow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveStockFromPackingslipRow(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveStockFromPackingslipRow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiSupplier {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    get(): Observable<Leverancier[]> {
        let url_ = this.baseUrl + "/api/supplier";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<Leverancier[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Leverancier[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Leverancier[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Leverancier.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiTask {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getAll(takeFive: boolean): Observable<BackgroundTask[]> {
        let url_ = this.baseUrl + "/api/tasks/all/{takeFive}";
        if (takeFive === undefined || takeFive === null)
            throw new Error("The parameter 'takeFive' must be defined.");
        url_ = url_.replace("{takeFive}", encodeURIComponent("" + takeFive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<BackgroundTask[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BackgroundTask[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BackgroundTask[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BackgroundTask.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    get(id: string): Observable<BackgroundTask> {
        let url_ = this.baseUrl + "/api/tasks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<BackgroundTask>><any>_observableThrow(e);
                }
            } else
                return <Observable<BackgroundTask>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BackgroundTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackgroundTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiUser {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getByKlant(klantId: number): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/users/customer/{klantId}";
        if (klantId === undefined || klantId === null)
            throw new Error("The parameter 'klantId' must be defined.");
        url_ = url_.replace("{klantId}", encodeURIComponent("" + klantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByKlant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByKlant(<any>response_);
                } catch (e) {
                    return <Observable<UserModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetByKlant(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    getById(userId: number): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<UserModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    isUserAlreadyExist(emailaddress: string | null): Observable<boolean> {
        let url_ = this.baseUrl + "/api/users/alreadyexist/{emailaddress}";
        if (emailaddress === undefined || emailaddress === null)
            throw new Error("The parameter 'emailaddress' must be defined.");
        url_ = url_.replace("{emailaddress}", encodeURIComponent("" + emailaddress));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsUserAlreadyExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsUserAlreadyExist(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsUserAlreadyExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    addUser(addUserRequest: AddUserRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addUserRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUser(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAddUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    updateUser(request: UpdateUserRequset): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    removeUser(userId?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUser(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    activateUser(request: ActivateUserRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateUser(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processActivateUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    changePassword(request: ChangePasswordRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/password/change";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    requestNewPassword(request: RequestNewPasswordRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/password/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestNewPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestNewPassword(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRequestNewPassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    resetPassword(request: ResetPasswordRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/password/setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiWebhook {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    saveMailResult(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/webhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMailResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMailResult(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSaveMailResult(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }

    myParcelStatusUpdate(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/webhook/myparcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMyParcelStatusUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMyParcelStatusUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processMyParcelStatusUpdate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiZipcode {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    get(zipcode?: string | null | undefined, housenumber?: string | null | undefined): Observable<GetAddressRespone> {
        let url_ = this.baseUrl + "/api/zipcode?";
        if (zipcode !== undefined && zipcode !== null)
            url_ += "zipcode=" + encodeURIComponent("" + zipcode) + "&";
        if (housenumber !== undefined && housenumber !== null)
            url_ += "housenumber=" + encodeURIComponent("" + housenumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<GetAddressRespone>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAddressRespone>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetAddressRespone> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAddressRespone.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    }
}

export class GetAlertsResponse implements IGetAlertsResponse {
    unreadCount?: number;
    alerts?: Alert[] | undefined;

    constructor(data?: IGetAlertsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreadCount = _data["unreadCount"];
            if (Array.isArray(_data["alerts"])) {
                this.alerts = [] as any;
                for (let item of _data["alerts"])
                    this.alerts!.push(Alert.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAlertsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlertsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        if (Array.isArray(this.alerts)) {
            data["alerts"] = [];
            for (let item of this.alerts)
                data["alerts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetAlertsResponse {
    unreadCount?: number;
    alerts?: Alert[] | undefined;
}

export class Alert implements IAlert {
    id?: number;
    volgNummer?: string;
    title?: string | undefined;
    description?: string | undefined;
    aangemaakt?: Date;
    isRead?: boolean;
    type?: AlertType;
    level?: AlertLevel;
    data?: { [key: string]: string; } | undefined;

    constructor(data?: IAlert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.volgNummer = _data["volgNummer"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.aangemaakt = _data["aangemaakt"] ? new Date(_data["aangemaakt"].toString()) : <any>undefined;
            this.isRead = _data["isRead"];
            this.type = _data["type"];
            this.level = _data["level"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
        }
    }

    static fromJS(data: any): Alert {
        data = typeof data === 'object' ? data : {};
        let result = new Alert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["volgNummer"] = this.volgNummer;
        data["title"] = this.title;
        data["description"] = this.description;
        data["aangemaakt"] = this.aangemaakt ? this.aangemaakt.toISOString() : <any>undefined;
        data["isRead"] = this.isRead;
        data["type"] = this.type;
        data["level"] = this.level;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = this.data[key];
            }
        }
        return data; 
    }
}

export interface IAlert {
    id?: number;
    volgNummer?: string;
    title?: string | undefined;
    description?: string | undefined;
    aangemaakt?: Date;
    isRead?: boolean;
    type?: AlertType;
    level?: AlertLevel;
    data?: { [key: string]: string; } | undefined;
}

export enum AlertType {
    Invoice = 0,
    Mail = 1,
    Payment = 2,
    Animal = 3,
    Other = 4,
}

export enum AlertLevel {
    Info = 0,
    Warning = 1,
    Error = 2,
}

export enum AddAnimalResult {
    Success = 0,
    AllreadyExist = 1,
    Updated = 2,
    Error = 3,
}

export class Dier implements IDier {
    id?: number;
    type?: number;
    nummer?: number;
    gewichtKoud?: number;
    gewichtWarm?: number;
    dierNummer?: string | undefined;
    batch?: Batch | undefined;
    boer?: Boer | undefined;

    constructor(data?: IDier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.nummer = _data["nummer"];
            this.gewichtKoud = _data["gewichtKoud"];
            this.gewichtWarm = _data["gewichtWarm"];
            this.dierNummer = _data["dierNummer"];
            this.batch = _data["batch"] ? Batch.fromJS(_data["batch"]) : <any>undefined;
            this.boer = _data["boer"] ? Boer.fromJS(_data["boer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Dier {
        data = typeof data === 'object' ? data : {};
        let result = new Dier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["nummer"] = this.nummer;
        data["gewichtKoud"] = this.gewichtKoud;
        data["gewichtWarm"] = this.gewichtWarm;
        data["dierNummer"] = this.dierNummer;
        data["batch"] = this.batch ? this.batch.toJSON() : <any>undefined;
        data["boer"] = this.boer ? this.boer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDier {
    id?: number;
    type?: number;
    nummer?: number;
    gewichtKoud?: number;
    gewichtWarm?: number;
    dierNummer?: string | undefined;
    batch?: Batch | undefined;
    boer?: Boer | undefined;
}

export class Batch implements IBatch {
    id?: number;
    datum?: Date;
    isClosed?: boolean;
    registratieNummer?: string | undefined;
    verzamelBatctNummer?: string | undefined;
    ras?: Ras | undefined;
    dierSoort?: DierSoort | undefined;
    dierSoortId?: number;
    boer?: Boer | undefined;
    boeren?: BatchBoer[] | undefined;
    leveracier?: Leverancier | undefined;

    constructor(data?: IBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.isClosed = _data["isClosed"];
            this.registratieNummer = _data["registratieNummer"];
            this.verzamelBatctNummer = _data["verzamelBatctNummer"];
            this.ras = _data["ras"] ? Ras.fromJS(_data["ras"]) : <any>undefined;
            this.dierSoort = _data["dierSoort"] ? DierSoort.fromJS(_data["dierSoort"]) : <any>undefined;
            this.dierSoortId = _data["dierSoortId"];
            this.boer = _data["boer"] ? Boer.fromJS(_data["boer"]) : <any>undefined;
            if (Array.isArray(_data["boeren"])) {
                this.boeren = [] as any;
                for (let item of _data["boeren"])
                    this.boeren!.push(BatchBoer.fromJS(item));
            }
            this.leveracier = _data["leveracier"] ? Leverancier.fromJS(_data["leveracier"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Batch {
        data = typeof data === 'object' ? data : {};
        let result = new Batch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["isClosed"] = this.isClosed;
        data["registratieNummer"] = this.registratieNummer;
        data["verzamelBatctNummer"] = this.verzamelBatctNummer;
        data["ras"] = this.ras ? this.ras.toJSON() : <any>undefined;
        data["dierSoort"] = this.dierSoort ? this.dierSoort.toJSON() : <any>undefined;
        data["dierSoortId"] = this.dierSoortId;
        data["boer"] = this.boer ? this.boer.toJSON() : <any>undefined;
        if (Array.isArray(this.boeren)) {
            data["boeren"] = [];
            for (let item of this.boeren)
                data["boeren"].push(item.toJSON());
        }
        data["leveracier"] = this.leveracier ? this.leveracier.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IBatch {
    id?: number;
    datum?: Date;
    isClosed?: boolean;
    registratieNummer?: string | undefined;
    verzamelBatctNummer?: string | undefined;
    ras?: Ras | undefined;
    dierSoort?: DierSoort | undefined;
    dierSoortId?: number;
    boer?: Boer | undefined;
    boeren?: BatchBoer[] | undefined;
    leveracier?: Leverancier | undefined;
}

export class Ras implements IRas {
    id?: number;
    naam?: string | undefined;

    constructor(data?: IRas) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naam = _data["naam"];
        }
    }

    static fromJS(data: any): Ras {
        data = typeof data === 'object' ? data : {};
        let result = new Ras();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naam"] = this.naam;
        return data; 
    }
}

export interface IRas {
    id?: number;
    naam?: string | undefined;
}

export class DierSoort implements IDierSoort {
    id?: number;
    naam?: string | undefined;

    constructor(data?: IDierSoort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naam = _data["naam"];
        }
    }

    static fromJS(data: any): DierSoort {
        data = typeof data === 'object' ? data : {};
        let result = new DierSoort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naam"] = this.naam;
        return data; 
    }
}

export interface IDierSoort {
    id?: number;
    naam?: string | undefined;
}

export class Boer implements IBoer {
    id?: number;
    naam?: string | undefined;
    adres?: string | undefined;
    postcode?: string | undefined;
    plaats?: string | undefined;
    boerderijNaam?: string | undefined;
    externalId?: number;

    constructor(data?: IBoer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naam = _data["naam"];
            this.adres = _data["adres"];
            this.postcode = _data["postcode"];
            this.plaats = _data["plaats"];
            this.boerderijNaam = _data["boerderijNaam"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): Boer {
        data = typeof data === 'object' ? data : {};
        let result = new Boer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naam"] = this.naam;
        data["adres"] = this.adres;
        data["postcode"] = this.postcode;
        data["plaats"] = this.plaats;
        data["boerderijNaam"] = this.boerderijNaam;
        data["externalId"] = this.externalId;
        return data; 
    }
}

export interface IBoer {
    id?: number;
    naam?: string | undefined;
    adres?: string | undefined;
    postcode?: string | undefined;
    plaats?: string | undefined;
    boerderijNaam?: string | undefined;
    externalId?: number;
}

export class BatchBoer implements IBatchBoer {
    batchId?: number;
    batch?: Batch | undefined;
    boerId?: number;
    boer?: Boer | undefined;

    constructor(data?: IBatchBoer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            this.batch = _data["batch"] ? Batch.fromJS(_data["batch"]) : <any>undefined;
            this.boerId = _data["boerId"];
            this.boer = _data["boer"] ? Boer.fromJS(_data["boer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BatchBoer {
        data = typeof data === 'object' ? data : {};
        let result = new BatchBoer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        data["batch"] = this.batch ? this.batch.toJSON() : <any>undefined;
        data["boerId"] = this.boerId;
        data["boer"] = this.boer ? this.boer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IBatchBoer {
    batchId?: number;
    batch?: Batch | undefined;
    boerId?: number;
    boer?: Boer | undefined;
}

export class Leverancier implements ILeverancier {
    id?: number;
    naam?: string | undefined;
    adres?: string | undefined;
    plaats?: string | undefined;
    postcode?: string | undefined;
    isActive?: boolean;

    constructor(data?: ILeverancier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naam = _data["naam"];
            this.adres = _data["adres"];
            this.plaats = _data["plaats"];
            this.postcode = _data["postcode"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): Leverancier {
        data = typeof data === 'object' ? data : {};
        let result = new Leverancier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naam"] = this.naam;
        data["adres"] = this.adres;
        data["plaats"] = this.plaats;
        data["postcode"] = this.postcode;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ILeverancier {
    id?: number;
    naam?: string | undefined;
    adres?: string | undefined;
    plaats?: string | undefined;
    postcode?: string | undefined;
    isActive?: boolean;
}

export class RefreshTokenResponse implements IRefreshTokenResponse {
    token?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        return data; 
    }
}

export interface IRefreshTokenResponse {
    token?: string | undefined;
    refreshToken?: string | undefined;
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
    expiredToken?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expiredToken = _data["expiredToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expiredToken"] = this.expiredToken;
        data["refreshToken"] = this.refreshToken;
        return data; 
    }
}

export interface IRefreshTokenRequest {
    expiredToken?: string | undefined;
    refreshToken?: string | undefined;
}

export class LoginResponse implements ILoginResponse {
    token?: string | undefined;
    refreshToken?: string | undefined;
    expired?: Date;
    user?: UserModel | undefined;
    featureFlags?: string[] | undefined;

    constructor(data?: ILoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.expired = _data["expired"] ? new Date(_data["expired"].toString()) : <any>undefined;
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["featureFlags"])) {
                this.featureFlags = [] as any;
                for (let item of _data["featureFlags"])
                    this.featureFlags!.push(item);
            }
        }
    }

    static fromJS(data: any): LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["expired"] = this.expired ? this.expired.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.featureFlags)) {
            data["featureFlags"] = [];
            for (let item of this.featureFlags)
                data["featureFlags"].push(item);
        }
        return data; 
    }
}

export interface ILoginResponse {
    token?: string | undefined;
    refreshToken?: string | undefined;
    expired?: Date;
    user?: UserModel | undefined;
    featureFlags?: string[] | undefined;
}

export class UserModel implements IUserModel {
    id?: number;
    fullName?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    isAccapted?: boolean;
    status?: UserStatus;
    role?: UserRole;
    createdDate?: Date;
    lastLoginDate?: Date | undefined;
    application?: Application;
    customerId?: number | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.isAccapted = _data["isAccapted"];
            this.status = _data["status"];
            this.role = _data["role"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastLoginDate = _data["lastLoginDate"] ? new Date(_data["lastLoginDate"].toString()) : <any>undefined;
            this.application = _data["application"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["isAccapted"] = this.isAccapted;
        data["status"] = this.status;
        data["role"] = this.role;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastLoginDate"] = this.lastLoginDate ? this.lastLoginDate.toISOString() : <any>undefined;
        data["application"] = this.application;
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface IUserModel {
    id?: number;
    fullName?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    isAccapted?: boolean;
    status?: UserStatus;
    role?: UserRole;
    createdDate?: Date;
    lastLoginDate?: Date | undefined;
    application?: Application;
    customerId?: number | undefined;
}

export enum UserStatus {
    New = 0,
    Active = 1,
    Inactive = 2,
}

export enum UserRole {
    Default = 0,
    Admin = 1,
    SuperAdmin = 2,
}

export enum Application {
    Portal = 0,
    Order = 1,
    API = 2,
    All = 3,
}

export class LoginRequest implements ILoginRequest {
    username?: string | undefined;
    password?: string | undefined;
    application?: string | undefined;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["application"] = this.application;
        return data; 
    }
}

export interface ILoginRequest {
    username?: string | undefined;
    password?: string | undefined;
    application?: string | undefined;
}

export class BatchInfoDto implements IBatchInfoDto {
    boeren?: Boer[] | undefined;
    batch?: Batch | undefined;
    totaalGewicht?: number;
    verlies?: number;
    totaalGewichtWarm?: number;
    aantalDieren?: number;
    gewichtDieren?: number;

    constructor(data?: IBatchInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["boeren"])) {
                this.boeren = [] as any;
                for (let item of _data["boeren"])
                    this.boeren!.push(Boer.fromJS(item));
            }
            this.batch = _data["batch"] ? Batch.fromJS(_data["batch"]) : <any>undefined;
            this.totaalGewicht = _data["totaalGewicht"];
            this.verlies = _data["verlies"];
            this.totaalGewichtWarm = _data["totaalGewichtWarm"];
            this.aantalDieren = _data["aantalDieren"];
            this.gewichtDieren = _data["gewichtDieren"];
        }
    }

    static fromJS(data: any): BatchInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.boeren)) {
            data["boeren"] = [];
            for (let item of this.boeren)
                data["boeren"].push(item.toJSON());
        }
        data["batch"] = this.batch ? this.batch.toJSON() : <any>undefined;
        data["totaalGewicht"] = this.totaalGewicht;
        data["verlies"] = this.verlies;
        data["totaalGewichtWarm"] = this.totaalGewichtWarm;
        data["aantalDieren"] = this.aantalDieren;
        data["gewichtDieren"] = this.gewichtDieren;
        return data; 
    }
}

export interface IBatchInfoDto {
    boeren?: Boer[] | undefined;
    batch?: Batch | undefined;
    totaalGewicht?: number;
    verlies?: number;
    totaalGewichtWarm?: number;
    aantalDieren?: number;
    gewichtDieren?: number;
}

export class GetCollectedBatchInformationResult implements IGetCollectedBatchInformationResult {
    farmers?: Boer[] | undefined;
    slaughterDate?: Date;
    animalType?: DierSoort | undefined;
    race?: Ras | undefined;
    product?: Product | undefined;

    constructor(data?: IGetCollectedBatchInformationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["farmers"])) {
                this.farmers = [] as any;
                for (let item of _data["farmers"])
                    this.farmers!.push(Boer.fromJS(item));
            }
            this.slaughterDate = _data["slaughterDate"] ? new Date(_data["slaughterDate"].toString()) : <any>undefined;
            this.animalType = _data["animalType"] ? DierSoort.fromJS(_data["animalType"]) : <any>undefined;
            this.race = _data["race"] ? Ras.fromJS(_data["race"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCollectedBatchInformationResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCollectedBatchInformationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.farmers)) {
            data["farmers"] = [];
            for (let item of this.farmers)
                data["farmers"].push(item.toJSON());
        }
        data["slaughterDate"] = this.slaughterDate ? this.slaughterDate.toISOString() : <any>undefined;
        data["animalType"] = this.animalType ? this.animalType.toJSON() : <any>undefined;
        data["race"] = this.race ? this.race.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCollectedBatchInformationResult {
    farmers?: Boer[] | undefined;
    slaughterDate?: Date;
    animalType?: DierSoort | undefined;
    race?: Ras | undefined;
    product?: Product | undefined;
}

export class Product implements IProduct {
    id?: number;
    naam?: string | undefined;
    omschrijving?: string | undefined;
    bereiding?: string | undefined;
    inWeegsysteem?: boolean;
    productieNaam?: string | undefined;
    consumentPrijs?: number;
    consumentPrijsIncBtw?: number;
    horecaPrijs?: number;
    opWebsite?: boolean;
    opHorecaSite?: boolean;
    gebruikProductGroepInfo?: boolean;
    stukGewicht?: number | undefined;
    ingredienten?: string | undefined;
    fotoPad?: string | undefined;
    houdbaarheid?: number;
    useForSaleScale?: boolean;
    storeWorldNumber?: number | undefined;
    metaData?: { [key: string]: any; } | undefined;
    deletedOn?: Date | undefined;
    standaardEenheid?: Eenheid | undefined;
    btw?: Btw | undefined;
    grootboek?: Grootboek | undefined;
    productEenheden?: ProductEenheid[] | undefined;
    productGroepen?: ProductGroepProduct[] | undefined;
    productAsParent?: ProductRelation[] | undefined;
    producsAsChild?: ProductRelation[] | undefined;
    productMutation?: Product | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naam = _data["naam"];
            this.omschrijving = _data["omschrijving"];
            this.bereiding = _data["bereiding"];
            this.inWeegsysteem = _data["inWeegsysteem"];
            this.productieNaam = _data["productieNaam"];
            this.consumentPrijs = _data["consumentPrijs"];
            this.consumentPrijsIncBtw = _data["consumentPrijsIncBtw"];
            this.horecaPrijs = _data["horecaPrijs"];
            this.opWebsite = _data["opWebsite"];
            this.opHorecaSite = _data["opHorecaSite"];
            this.gebruikProductGroepInfo = _data["gebruikProductGroepInfo"];
            this.stukGewicht = _data["stukGewicht"];
            this.ingredienten = _data["ingredienten"];
            this.fotoPad = _data["fotoPad"];
            this.houdbaarheid = _data["houdbaarheid"];
            this.useForSaleScale = _data["useForSaleScale"];
            this.storeWorldNumber = _data["storeWorldNumber"];
            if (_data["metaData"]) {
                this.metaData = {} as any;
                for (let key in _data["metaData"]) {
                    if (_data["metaData"].hasOwnProperty(key))
                        (<any>this.metaData)![key] = _data["metaData"][key];
                }
            }
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.standaardEenheid = _data["standaardEenheid"] ? Eenheid.fromJS(_data["standaardEenheid"]) : <any>undefined;
            this.btw = _data["btw"] ? Btw.fromJS(_data["btw"]) : <any>undefined;
            this.grootboek = _data["grootboek"] ? Grootboek.fromJS(_data["grootboek"]) : <any>undefined;
            if (Array.isArray(_data["productEenheden"])) {
                this.productEenheden = [] as any;
                for (let item of _data["productEenheden"])
                    this.productEenheden!.push(ProductEenheid.fromJS(item));
            }
            if (Array.isArray(_data["productGroepen"])) {
                this.productGroepen = [] as any;
                for (let item of _data["productGroepen"])
                    this.productGroepen!.push(ProductGroepProduct.fromJS(item));
            }
            if (Array.isArray(_data["productAsParent"])) {
                this.productAsParent = [] as any;
                for (let item of _data["productAsParent"])
                    this.productAsParent!.push(ProductRelation.fromJS(item));
            }
            if (Array.isArray(_data["producsAsChild"])) {
                this.producsAsChild = [] as any;
                for (let item of _data["producsAsChild"])
                    this.producsAsChild!.push(ProductRelation.fromJS(item));
            }
            this.productMutation = _data["productMutation"] ? Product.fromJS(_data["productMutation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naam"] = this.naam;
        data["omschrijving"] = this.omschrijving;
        data["bereiding"] = this.bereiding;
        data["inWeegsysteem"] = this.inWeegsysteem;
        data["productieNaam"] = this.productieNaam;
        data["consumentPrijs"] = this.consumentPrijs;
        data["consumentPrijsIncBtw"] = this.consumentPrijsIncBtw;
        data["horecaPrijs"] = this.horecaPrijs;
        data["opWebsite"] = this.opWebsite;
        data["opHorecaSite"] = this.opHorecaSite;
        data["gebruikProductGroepInfo"] = this.gebruikProductGroepInfo;
        data["stukGewicht"] = this.stukGewicht;
        data["ingredienten"] = this.ingredienten;
        data["fotoPad"] = this.fotoPad;
        data["houdbaarheid"] = this.houdbaarheid;
        data["useForSaleScale"] = this.useForSaleScale;
        data["storeWorldNumber"] = this.storeWorldNumber;
        if (this.metaData) {
            data["metaData"] = {};
            for (let key in this.metaData) {
                if (this.metaData.hasOwnProperty(key))
                    (<any>data["metaData"])[key] = this.metaData[key];
            }
        }
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["standaardEenheid"] = this.standaardEenheid ? this.standaardEenheid.toJSON() : <any>undefined;
        data["btw"] = this.btw ? this.btw.toJSON() : <any>undefined;
        data["grootboek"] = this.grootboek ? this.grootboek.toJSON() : <any>undefined;
        if (Array.isArray(this.productEenheden)) {
            data["productEenheden"] = [];
            for (let item of this.productEenheden)
                data["productEenheden"].push(item.toJSON());
        }
        if (Array.isArray(this.productGroepen)) {
            data["productGroepen"] = [];
            for (let item of this.productGroepen)
                data["productGroepen"].push(item.toJSON());
        }
        if (Array.isArray(this.productAsParent)) {
            data["productAsParent"] = [];
            for (let item of this.productAsParent)
                data["productAsParent"].push(item.toJSON());
        }
        if (Array.isArray(this.producsAsChild)) {
            data["producsAsChild"] = [];
            for (let item of this.producsAsChild)
                data["producsAsChild"].push(item.toJSON());
        }
        data["productMutation"] = this.productMutation ? this.productMutation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IProduct {
    id?: number;
    naam?: string | undefined;
    omschrijving?: string | undefined;
    bereiding?: string | undefined;
    inWeegsysteem?: boolean;
    productieNaam?: string | undefined;
    consumentPrijs?: number;
    consumentPrijsIncBtw?: number;
    horecaPrijs?: number;
    opWebsite?: boolean;
    opHorecaSite?: boolean;
    gebruikProductGroepInfo?: boolean;
    stukGewicht?: number | undefined;
    ingredienten?: string | undefined;
    fotoPad?: string | undefined;
    houdbaarheid?: number;
    useForSaleScale?: boolean;
    storeWorldNumber?: number | undefined;
    metaData?: { [key: string]: any; } | undefined;
    deletedOn?: Date | undefined;
    standaardEenheid?: Eenheid | undefined;
    btw?: Btw | undefined;
    grootboek?: Grootboek | undefined;
    productEenheden?: ProductEenheid[] | undefined;
    productGroepen?: ProductGroepProduct[] | undefined;
    productAsParent?: ProductRelation[] | undefined;
    producsAsChild?: ProductRelation[] | undefined;
    productMutation?: Product | undefined;
}

export class Eenheid implements IEenheid {
    id?: number;
    naam?: string | undefined;

    constructor(data?: IEenheid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naam = _data["naam"];
        }
    }

    static fromJS(data: any): Eenheid {
        data = typeof data === 'object' ? data : {};
        let result = new Eenheid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naam"] = this.naam;
        return data; 
    }
}

export interface IEenheid {
    id?: number;
    naam?: string | undefined;
}

export class Btw implements IBtw {
    id?: number;
    percentage?: number;
    naam?: string | undefined;
    berekening?: number;
    grootboek?: number;
    isActive?: boolean;

    constructor(data?: IBtw) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.percentage = _data["percentage"];
            this.naam = _data["naam"];
            this.berekening = _data["berekening"];
            this.grootboek = _data["grootboek"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): Btw {
        data = typeof data === 'object' ? data : {};
        let result = new Btw();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["percentage"] = this.percentage;
        data["naam"] = this.naam;
        data["berekening"] = this.berekening;
        data["grootboek"] = this.grootboek;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IBtw {
    id?: number;
    percentage?: number;
    naam?: string | undefined;
    berekening?: number;
    grootboek?: number;
    isActive?: boolean;
}

export class Grootboek implements IGrootboek {
    id?: number;
    nummer?: number;
    omschrijving?: string | undefined;
    isCredit?: boolean;
    isInclusive?: boolean;
    isActive?: boolean;
    btwId?: number;
    btw?: Btw | undefined;

    constructor(data?: IGrootboek) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nummer = _data["nummer"];
            this.omschrijving = _data["omschrijving"];
            this.isCredit = _data["isCredit"];
            this.isInclusive = _data["isInclusive"];
            this.isActive = _data["isActive"];
            this.btwId = _data["btwId"];
            this.btw = _data["btw"] ? Btw.fromJS(_data["btw"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Grootboek {
        data = typeof data === 'object' ? data : {};
        let result = new Grootboek();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nummer"] = this.nummer;
        data["omschrijving"] = this.omschrijving;
        data["isCredit"] = this.isCredit;
        data["isInclusive"] = this.isInclusive;
        data["isActive"] = this.isActive;
        data["btwId"] = this.btwId;
        data["btw"] = this.btw ? this.btw.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGrootboek {
    id?: number;
    nummer?: number;
    omschrijving?: string | undefined;
    isCredit?: boolean;
    isInclusive?: boolean;
    isActive?: boolean;
    btwId?: number;
    btw?: Btw | undefined;
}

export class ProductEenheid implements IProductEenheid {
    productId?: number;
    eenheidId?: number;
    eenheid?: Eenheid | undefined;

    constructor(data?: IProductEenheid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.eenheidId = _data["eenheidId"];
            this.eenheid = _data["eenheid"] ? Eenheid.fromJS(_data["eenheid"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductEenheid {
        data = typeof data === 'object' ? data : {};
        let result = new ProductEenheid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["eenheidId"] = this.eenheidId;
        data["eenheid"] = this.eenheid ? this.eenheid.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IProductEenheid {
    productId?: number;
    eenheidId?: number;
    eenheid?: Eenheid | undefined;
}

export class ProductGroepProduct implements IProductGroepProduct {
    productId?: number;
    productgroepId?: number;
    productgroep?: ProductGroep | undefined;

    constructor(data?: IProductGroepProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productgroepId = _data["productgroepId"];
            this.productgroep = _data["productgroep"] ? ProductGroep.fromJS(_data["productgroep"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductGroepProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGroepProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productgroepId"] = this.productgroepId;
        data["productgroep"] = this.productgroep ? this.productgroep.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IProductGroepProduct {
    productId?: number;
    productgroepId?: number;
    productgroep?: ProductGroep | undefined;
}

export class ProductGroep implements IProductGroep {
    id?: number;
    naam?: string | undefined;
    groepInformatie?: string | undefined;

    constructor(data?: IProductGroep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naam = _data["naam"];
            this.groepInformatie = _data["groepInformatie"];
        }
    }

    static fromJS(data: any): ProductGroep {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGroep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naam"] = this.naam;
        data["groepInformatie"] = this.groepInformatie;
        return data; 
    }
}

export interface IProductGroep {
    id?: number;
    naam?: string | undefined;
    groepInformatie?: string | undefined;
}

export class ProductRelation implements IProductRelation {
    parentProductId?: number;
    parentProduct?: Product | undefined;
    childProductId?: number;
    childProduct?: Product | undefined;

    constructor(data?: IProductRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentProductId = _data["parentProductId"];
            this.parentProduct = _data["parentProduct"] ? Product.fromJS(_data["parentProduct"]) : <any>undefined;
            this.childProductId = _data["childProductId"];
            this.childProduct = _data["childProduct"] ? Product.fromJS(_data["childProduct"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductRelation {
        data = typeof data === 'object' ? data : {};
        let result = new ProductRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentProductId"] = this.parentProductId;
        data["parentProduct"] = this.parentProduct ? this.parentProduct.toJSON() : <any>undefined;
        data["childProductId"] = this.childProductId;
        data["childProduct"] = this.childProduct ? this.childProduct.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IProductRelation {
    parentProductId?: number;
    parentProduct?: Product | undefined;
    childProductId?: number;
    childProduct?: Product | undefined;
}

export class Bericht implements IBericht {
    id?: number;
    title?: string | undefined;
    message?: string | undefined;
    url?: string | undefined;
    showOnLogin?: boolean;
    createdOn?: Date;
    deletedOn?: Date;

    constructor(data?: IBericht) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.message = _data["message"];
            this.url = _data["url"];
            this.showOnLogin = _data["showOnLogin"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Bericht {
        data = typeof data === 'object' ? data : {};
        let result = new Bericht();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["message"] = this.message;
        data["url"] = this.url;
        data["showOnLogin"] = this.showOnLogin;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IBericht {
    id?: number;
    title?: string | undefined;
    message?: string | undefined;
    url?: string | undefined;
    showOnLogin?: boolean;
    createdOn?: Date;
    deletedOn?: Date;
}

export class CalculateOrderCostsResponse implements ICalculateOrderCostsResponse {
    subTotal?: number;
    totalAmount?: number;
    shippingCosts?: number;
    shipmentProviderCosts?: number;
    shipmentBoxCost?: number;

    constructor(data?: ICalculateOrderCostsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subTotal = _data["subTotal"];
            this.totalAmount = _data["totalAmount"];
            this.shippingCosts = _data["shippingCosts"];
            this.shipmentProviderCosts = _data["shipmentProviderCosts"];
            this.shipmentBoxCost = _data["shipmentBoxCost"];
        }
    }

    static fromJS(data: any): CalculateOrderCostsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateOrderCostsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subTotal"] = this.subTotal;
        data["totalAmount"] = this.totalAmount;
        data["shippingCosts"] = this.shippingCosts;
        data["shipmentProviderCosts"] = this.shipmentProviderCosts;
        data["shipmentBoxCost"] = this.shipmentBoxCost;
        return data; 
    }
}

export interface ICalculateOrderCostsResponse {
    subTotal?: number;
    totalAmount?: number;
    shippingCosts?: number;
    shipmentProviderCosts?: number;
    shipmentBoxCost?: number;
}

export class CalculateOrderCostsRequest implements ICalculateOrderCostsRequest {
    orderRegels?: OrderRegel[] | undefined;
    zipCode?: string | undefined;
    needsToBeDelivered?: boolean;

    constructor(data?: ICalculateOrderCostsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderRegels"])) {
                this.orderRegels = [] as any;
                for (let item of _data["orderRegels"])
                    this.orderRegels!.push(OrderRegel.fromJS(item));
            }
            this.zipCode = _data["zipCode"];
            this.needsToBeDelivered = _data["needsToBeDelivered"];
        }
    }

    static fromJS(data: any): CalculateOrderCostsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateOrderCostsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderRegels)) {
            data["orderRegels"] = [];
            for (let item of this.orderRegels)
                data["orderRegels"].push(item.toJSON());
        }
        data["zipCode"] = this.zipCode;
        data["needsToBeDelivered"] = this.needsToBeDelivered;
        return data; 
    }
}

export interface ICalculateOrderCostsRequest {
    orderRegels?: OrderRegel[] | undefined;
    zipCode?: string | undefined;
    needsToBeDelivered?: boolean;
}

export class OrderRegel implements IOrderRegel {
    id?: number;
    omschrijving?: string | undefined;
    aantal?: number;
    opmerking?: string | undefined;
    eenheidId?: number;
    eenheid?: Eenheid | undefined;
    productId?: number;
    product?: Product | undefined;

    constructor(data?: IOrderRegel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.omschrijving = _data["omschrijving"];
            this.aantal = _data["aantal"];
            this.opmerking = _data["opmerking"];
            this.eenheidId = _data["eenheidId"];
            this.eenheid = _data["eenheid"] ? Eenheid.fromJS(_data["eenheid"]) : <any>undefined;
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderRegel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRegel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["omschrijving"] = this.omschrijving;
        data["aantal"] = this.aantal;
        data["opmerking"] = this.opmerking;
        data["eenheidId"] = this.eenheidId;
        data["eenheid"] = this.eenheid ? this.eenheid.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IOrderRegel {
    id?: number;
    omschrijving?: string | undefined;
    aantal?: number;
    opmerking?: string | undefined;
    eenheidId?: number;
    eenheid?: Eenheid | undefined;
    productId?: number;
    product?: Product | undefined;
}

export class Bedrijfsgegevens implements IBedrijfsgegevens {
    id?: number;
    companyName?: string | undefined;
    address?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    website?: string | undefined;
    phonenumber?: string | undefined;
    emailAddress?: string | undefined;
    iban?: string | undefined;
    vatNumber?: string | undefined;

    constructor(data?: IBedrijfsgegevens) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyName = _data["companyName"];
            this.address = _data["address"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.website = _data["website"];
            this.phonenumber = _data["phonenumber"];
            this.emailAddress = _data["emailAddress"];
            this.iban = _data["iban"];
            this.vatNumber = _data["vatNumber"];
        }
    }

    static fromJS(data: any): Bedrijfsgegevens {
        data = typeof data === 'object' ? data : {};
        let result = new Bedrijfsgegevens();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyName"] = this.companyName;
        data["address"] = this.address;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["website"] = this.website;
        data["phonenumber"] = this.phonenumber;
        data["emailAddress"] = this.emailAddress;
        data["iban"] = this.iban;
        data["vatNumber"] = this.vatNumber;
        return data; 
    }
}

export interface IBedrijfsgegevens {
    id?: number;
    companyName?: string | undefined;
    address?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    website?: string | undefined;
    phonenumber?: string | undefined;
    emailAddress?: string | undefined;
    iban?: string | undefined;
    vatNumber?: string | undefined;
}

export class PiChartDto implements IPiChartDto {
    data?: number[] | undefined;
    labels?: string[] | undefined;

    constructor(data?: IPiChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
        }
    }

    static fromJS(data: any): PiChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new PiChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        return data; 
    }
}

export interface IPiChartDto {
    data?: number[] | undefined;
    labels?: string[] | undefined;
}

export class GraphDto implements IGraphDto {
    dataListOne?: InnerGraphDto | undefined;
    dataListTwo?: InnerGraphDto | undefined;
    labels?: string[] | undefined;

    constructor(data?: IGraphDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataListOne = _data["dataListOne"] ? InnerGraphDto.fromJS(_data["dataListOne"]) : <any>undefined;
            this.dataListTwo = _data["dataListTwo"] ? InnerGraphDto.fromJS(_data["dataListTwo"]) : <any>undefined;
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
        }
    }

    static fromJS(data: any): GraphDto {
        data = typeof data === 'object' ? data : {};
        let result = new GraphDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataListOne"] = this.dataListOne ? this.dataListOne.toJSON() : <any>undefined;
        data["dataListTwo"] = this.dataListTwo ? this.dataListTwo.toJSON() : <any>undefined;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        return data; 
    }
}

export interface IGraphDto {
    dataListOne?: InnerGraphDto | undefined;
    dataListTwo?: InnerGraphDto | undefined;
    labels?: string[] | undefined;
}

export class InnerGraphDto implements IInnerGraphDto {
    data?: number[] | undefined;
    label?: string | undefined;

    constructor(data?: IInnerGraphDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): InnerGraphDto {
        data = typeof data === 'object' ? data : {};
        let result = new InnerGraphDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["label"] = this.label;
        return data; 
    }
}

export interface IInnerGraphDto {
    data?: number[] | undefined;
    label?: string | undefined;
}

export class GetOustandingInvoicesResponse implements IGetOustandingInvoicesResponse {
    outstandingCount?: number;
    oustandingAmount?: number;

    constructor(data?: IGetOustandingInvoicesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outstandingCount = _data["outstandingCount"];
            this.oustandingAmount = _data["oustandingAmount"];
        }
    }

    static fromJS(data: any): GetOustandingInvoicesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOustandingInvoicesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outstandingCount"] = this.outstandingCount;
        data["oustandingAmount"] = this.oustandingAmount;
        return data; 
    }
}

export interface IGetOustandingInvoicesResponse {
    outstandingCount?: number;
    oustandingAmount?: number;
}

export class GetActionsResponse implements IGetActionsResponse {
    actions?: Action[] | undefined;

    constructor(data?: IGetActionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(Action.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetActionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetActionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetActionsResponse {
    actions?: Action[] | undefined;
}

export class Action implements IAction {
    description?: string | undefined;
    url?: string | undefined;

    constructor(data?: IAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): Action {
        data = typeof data === 'object' ? data : {};
        let result = new Action();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["url"] = this.url;
        return data; 
    }
}

export interface IAction {
    description?: string | undefined;
    url?: string | undefined;
}

export class GetTotalResultResponse implements IGetTotalResultResponse {
    amounts?: { [key: string]: number; } | undefined;

    constructor(data?: IGetTotalResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["amounts"]) {
                this.amounts = {} as any;
                for (let key in _data["amounts"]) {
                    if (_data["amounts"].hasOwnProperty(key))
                        (<any>this.amounts)![key] = _data["amounts"][key];
                }
            }
        }
    }

    static fromJS(data: any): GetTotalResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTotalResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.amounts) {
            data["amounts"] = {};
            for (let key in this.amounts) {
                if (this.amounts.hasOwnProperty(key))
                    (<any>data["amounts"])[key] = this.amounts[key];
            }
        }
        return data; 
    }
}

export interface IGetTotalResultResponse {
    amounts?: { [key: string]: number; } | undefined;
}

export class GetShipmentStatusRespone implements IGetShipmentStatusRespone {
    shipmentStatusses?: { [key: string]: number; } | undefined;

    constructor(data?: IGetShipmentStatusRespone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["shipmentStatusses"]) {
                this.shipmentStatusses = {} as any;
                for (let key in _data["shipmentStatusses"]) {
                    if (_data["shipmentStatusses"].hasOwnProperty(key))
                        (<any>this.shipmentStatusses)![key] = _data["shipmentStatusses"][key];
                }
            }
        }
    }

    static fromJS(data: any): GetShipmentStatusRespone {
        data = typeof data === 'object' ? data : {};
        let result = new GetShipmentStatusRespone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.shipmentStatusses) {
            data["shipmentStatusses"] = {};
            for (let key in this.shipmentStatusses) {
                if (this.shipmentStatusses.hasOwnProperty(key))
                    (<any>data["shipmentStatusses"])[key] = this.shipmentStatusses[key];
            }
        }
        return data; 
    }
}

export interface IGetShipmentStatusRespone {
    shipmentStatusses?: { [key: string]: number; } | undefined;
}

export enum ShipmentType {
    PostNL = 0,
    MyParcel = 1,
}

export class GetWeekRevenueResponse implements IGetWeekRevenueResponse {
    weekNumber?: number;
    year?: number;
    pastYear?: number;
    revenueAmount?: number;
    pastRevenueAmount?: number;

    constructor(data?: IGetWeekRevenueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekNumber = _data["weekNumber"];
            this.year = _data["year"];
            this.pastYear = _data["pastYear"];
            this.revenueAmount = _data["revenueAmount"];
            this.pastRevenueAmount = _data["pastRevenueAmount"];
        }
    }

    static fromJS(data: any): GetWeekRevenueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWeekRevenueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekNumber"] = this.weekNumber;
        data["year"] = this.year;
        data["pastYear"] = this.pastYear;
        data["revenueAmount"] = this.revenueAmount;
        data["pastRevenueAmount"] = this.pastRevenueAmount;
        return data; 
    }
}

export interface IGetWeekRevenueResponse {
    weekNumber?: number;
    year?: number;
    pastYear?: number;
    revenueAmount?: number;
    pastRevenueAmount?: number;
}

export class GetMonthRevenueResponse implements IGetMonthRevenueResponse {
    month?: string | undefined;
    year?: number;
    pastYear?: number;
    revenueAmount?: number;
    pastRevenueAmount?: number;

    constructor(data?: IGetMonthRevenueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.year = _data["year"];
            this.pastYear = _data["pastYear"];
            this.revenueAmount = _data["revenueAmount"];
            this.pastRevenueAmount = _data["pastRevenueAmount"];
        }
    }

    static fromJS(data: any): GetMonthRevenueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthRevenueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        data["pastYear"] = this.pastYear;
        data["revenueAmount"] = this.revenueAmount;
        data["pastRevenueAmount"] = this.pastRevenueAmount;
        return data; 
    }
}

export interface IGetMonthRevenueResponse {
    month?: string | undefined;
    year?: number;
    pastYear?: number;
    revenueAmount?: number;
    pastRevenueAmount?: number;
}

export class GetBusinessHoursRespone implements IGetBusinessHoursRespone {
    result?: Result | undefined;

    constructor(data?: IGetBusinessHoursRespone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? Result.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBusinessHoursRespone {
        data = typeof data === 'object' ? data : {};
        let result = new GetBusinessHoursRespone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetBusinessHoursRespone {
    result?: Result | undefined;
}

export class Result implements IResult {
    opening_hours?: OpeningHours | undefined;

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opening_hours = _data["opening_hours"] ? OpeningHours.fromJS(_data["opening_hours"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opening_hours"] = this.opening_hours ? this.opening_hours.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IResult {
    opening_hours?: OpeningHours | undefined;
}

export class OpeningHours implements IOpeningHours {
    open_now?: boolean;
    periods?: Period[] | undefined;
    weekday_text?: string[] | undefined;

    constructor(data?: IOpeningHours) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.open_now = _data["open_now"];
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(Period.fromJS(item));
            }
            if (Array.isArray(_data["weekday_text"])) {
                this.weekday_text = [] as any;
                for (let item of _data["weekday_text"])
                    this.weekday_text!.push(item);
            }
        }
    }

    static fromJS(data: any): OpeningHours {
        data = typeof data === 'object' ? data : {};
        let result = new OpeningHours();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["open_now"] = this.open_now;
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item.toJSON());
        }
        if (Array.isArray(this.weekday_text)) {
            data["weekday_text"] = [];
            for (let item of this.weekday_text)
                data["weekday_text"].push(item);
        }
        return data; 
    }
}

export interface IOpeningHours {
    open_now?: boolean;
    periods?: Period[] | undefined;
    weekday_text?: string[] | undefined;
}

export class Period implements IPeriod {
    close?: Close | undefined;
    open?: Open | undefined;

    constructor(data?: IPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.close = _data["close"] ? Close.fromJS(_data["close"]) : <any>undefined;
            this.open = _data["open"] ? Open.fromJS(_data["open"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Period {
        data = typeof data === 'object' ? data : {};
        let result = new Period();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["close"] = this.close ? this.close.toJSON() : <any>undefined;
        data["open"] = this.open ? this.open.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPeriod {
    close?: Close | undefined;
    open?: Open | undefined;
}

export class Close implements IClose {
    day?: number;
    time?: string | undefined;

    constructor(data?: IClose) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.time = _data["time"];
        }
    }

    static fromJS(data: any): Close {
        data = typeof data === 'object' ? data : {};
        let result = new Close();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["time"] = this.time;
        return data; 
    }
}

export interface IClose {
    day?: number;
    time?: string | undefined;
}

export class Open implements IOpen {
    day?: number;
    time?: string | undefined;

    constructor(data?: IOpen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.time = _data["time"];
        }
    }

    static fromJS(data: any): Open {
        data = typeof data === 'object' ? data : {};
        let result = new Open();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["time"] = this.time;
        return data; 
    }
}

export interface IOpen {
    day?: number;
    time?: string | undefined;
}

export class SnelStartGrootboekDto implements ISnelStartGrootboekDto {
    omschrijving?: string | undefined;
    nummer?: number;

    constructor(data?: ISnelStartGrootboekDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.omschrijving = _data["omschrijving"];
            this.nummer = _data["nummer"];
        }
    }

    static fromJS(data: any): SnelStartGrootboekDto {
        data = typeof data === 'object' ? data : {};
        let result = new SnelStartGrootboekDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["omschrijving"] = this.omschrijving;
        data["nummer"] = this.nummer;
        return data; 
    }
}

export interface ISnelStartGrootboekDto {
    omschrijving?: string | undefined;
    nummer?: number;
}

export class Pakbon implements IPakbon {
    id?: number;
    order?: Order | undefined;
    klant?: Klant | undefined;
    aflevertijd?: Date | undefined;
    datum?: Date;
    opmerking?: string | undefined;
    factuurNummer?: number | undefined;
    isClosed?: boolean;
    mailIdentifier?: string | undefined;
    regels?: PakbonRegel[] | undefined;
    verzendlabels?: Verzendlabel[] | undefined;

    constructor(data?: IPakbon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.klant = _data["klant"] ? Klant.fromJS(_data["klant"]) : <any>undefined;
            this.aflevertijd = _data["aflevertijd"] ? new Date(_data["aflevertijd"].toString()) : <any>undefined;
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.opmerking = _data["opmerking"];
            this.factuurNummer = _data["factuurNummer"];
            this.isClosed = _data["isClosed"];
            this.mailIdentifier = _data["mailIdentifier"];
            if (Array.isArray(_data["regels"])) {
                this.regels = [] as any;
                for (let item of _data["regels"])
                    this.regels!.push(PakbonRegel.fromJS(item));
            }
            if (Array.isArray(_data["verzendlabels"])) {
                this.verzendlabels = [] as any;
                for (let item of _data["verzendlabels"])
                    this.verzendlabels!.push(Verzendlabel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Pakbon {
        data = typeof data === 'object' ? data : {};
        let result = new Pakbon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["klant"] = this.klant ? this.klant.toJSON() : <any>undefined;
        data["aflevertijd"] = this.aflevertijd ? this.aflevertijd.toISOString() : <any>undefined;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["opmerking"] = this.opmerking;
        data["factuurNummer"] = this.factuurNummer;
        data["isClosed"] = this.isClosed;
        data["mailIdentifier"] = this.mailIdentifier;
        if (Array.isArray(this.regels)) {
            data["regels"] = [];
            for (let item of this.regels)
                data["regels"].push(item.toJSON());
        }
        if (Array.isArray(this.verzendlabels)) {
            data["verzendlabels"] = [];
            for (let item of this.verzendlabels)
                data["verzendlabels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPakbon {
    id?: number;
    order?: Order | undefined;
    klant?: Klant | undefined;
    aflevertijd?: Date | undefined;
    datum?: Date;
    opmerking?: string | undefined;
    factuurNummer?: number | undefined;
    isClosed?: boolean;
    mailIdentifier?: string | undefined;
    regels?: PakbonRegel[] | undefined;
    verzendlabels?: Verzendlabel[] | undefined;
}

export class Order implements IOrder {
    id?: number;
    bestelDatum?: Date;
    leverDatum?: Date;
    totaalbedrag?: number;
    verzendkosten?: number;
    bezorgen?: boolean;
    besteldDoor?: string | undefined;
    opmerking?: string | undefined;
    isVerwerkt?: boolean;
    klant?: Klant | undefined;
    orderRegels?: OrderRegel[] | undefined;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bestelDatum = _data["bestelDatum"] ? new Date(_data["bestelDatum"].toString()) : <any>undefined;
            this.leverDatum = _data["leverDatum"] ? new Date(_data["leverDatum"].toString()) : <any>undefined;
            this.totaalbedrag = _data["totaalbedrag"];
            this.verzendkosten = _data["verzendkosten"];
            this.bezorgen = _data["bezorgen"];
            this.besteldDoor = _data["besteldDoor"];
            this.opmerking = _data["opmerking"];
            this.isVerwerkt = _data["isVerwerkt"];
            this.klant = _data["klant"] ? Klant.fromJS(_data["klant"]) : <any>undefined;
            if (Array.isArray(_data["orderRegels"])) {
                this.orderRegels = [] as any;
                for (let item of _data["orderRegels"])
                    this.orderRegels!.push(OrderRegel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bestelDatum"] = this.bestelDatum ? this.bestelDatum.toISOString() : <any>undefined;
        data["leverDatum"] = this.leverDatum ? this.leverDatum.toISOString() : <any>undefined;
        data["totaalbedrag"] = this.totaalbedrag;
        data["verzendkosten"] = this.verzendkosten;
        data["bezorgen"] = this.bezorgen;
        data["besteldDoor"] = this.besteldDoor;
        data["opmerking"] = this.opmerking;
        data["isVerwerkt"] = this.isVerwerkt;
        data["klant"] = this.klant ? this.klant.toJSON() : <any>undefined;
        if (Array.isArray(this.orderRegels)) {
            data["orderRegels"] = [];
            for (let item of this.orderRegels)
                data["orderRegels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOrder {
    id?: number;
    bestelDatum?: Date;
    leverDatum?: Date;
    totaalbedrag?: number;
    verzendkosten?: number;
    bezorgen?: boolean;
    besteldDoor?: string | undefined;
    opmerking?: string | undefined;
    isVerwerkt?: boolean;
    klant?: Klant | undefined;
    orderRegels?: OrderRegel[] | undefined;
}

export class Klant implements IKlant {
    id?: number;
    naam?: string | undefined;
    voornaam?: string | undefined;
    tussenvoegsel?: string | undefined;
    achternaam?: string | undefined;
    bedrijfsnaam?: string | undefined;
    volledigeNaam?: string | undefined;
    adres?: string | undefined;
    straat?: string | undefined;
    huisnummer?: string | undefined;
    huisnummerToevoeging?: string | undefined;
    adresToevoeging?: string | undefined;
    postcode?: string | undefined;
    plaats?: string | undefined;
    telefoon?: string | undefined;
    email?: string | undefined;
    emailPakbon?: string | undefined;
    emailFactuur?: string | undefined;
    debiteurNummer?: number;
    isParticulier?: boolean;
    isIncassoKlant?: boolean;
    sendInvoiceDigital?: boolean;
    sendPackingSlipDigital?: boolean;
    sendOrderConfirmation?: boolean;
    useCorrespondentieAdresForInvoice?: boolean;
    addPaymentLinkToMailTemplate?: boolean;
    contactPersoon?: string | undefined;
    contactEmailAdres?: string | undefined;
    contactTelefoonnummer?: string | undefined;
    notitie?: string | undefined;
    correspondentieAdres?: string | undefined;
    correspondentieStraat?: string | undefined;
    correspondentieHuisnummer?: string | undefined;
    correspondentieHuisnummerToevoeging?: string | undefined;
    correspondentieAdresToevoeging?: string | undefined;
    correspondentiePostcode?: string | undefined;
    correspondentiePlaats?: string | undefined;
    correspondentieEmail?: string | undefined;
    correspondentieTelefoon?: string | undefined;
    correspondentieContact?: string | undefined;
    deletedOn?: Date | undefined;
    bestellijst?: Bestellijst | undefined;

    constructor(data?: IKlant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naam = _data["naam"];
            this.voornaam = _data["voornaam"];
            this.tussenvoegsel = _data["tussenvoegsel"];
            this.achternaam = _data["achternaam"];
            this.bedrijfsnaam = _data["bedrijfsnaam"];
            this.volledigeNaam = _data["volledigeNaam"];
            this.adres = _data["adres"];
            this.straat = _data["straat"];
            this.huisnummer = _data["huisnummer"];
            this.huisnummerToevoeging = _data["huisnummerToevoeging"];
            this.adresToevoeging = _data["adresToevoeging"];
            this.postcode = _data["postcode"];
            this.plaats = _data["plaats"];
            this.telefoon = _data["telefoon"];
            this.email = _data["email"];
            this.emailPakbon = _data["emailPakbon"];
            this.emailFactuur = _data["emailFactuur"];
            this.debiteurNummer = _data["debiteurNummer"];
            this.isParticulier = _data["isParticulier"];
            this.isIncassoKlant = _data["isIncassoKlant"];
            this.sendInvoiceDigital = _data["sendInvoiceDigital"];
            this.sendPackingSlipDigital = _data["sendPackingSlipDigital"];
            this.sendOrderConfirmation = _data["sendOrderConfirmation"];
            this.useCorrespondentieAdresForInvoice = _data["useCorrespondentieAdresForInvoice"];
            this.addPaymentLinkToMailTemplate = _data["addPaymentLinkToMailTemplate"];
            this.contactPersoon = _data["contactPersoon"];
            this.contactEmailAdres = _data["contactEmailAdres"];
            this.contactTelefoonnummer = _data["contactTelefoonnummer"];
            this.notitie = _data["notitie"];
            this.correspondentieAdres = _data["correspondentieAdres"];
            this.correspondentieStraat = _data["correspondentieStraat"];
            this.correspondentieHuisnummer = _data["correspondentieHuisnummer"];
            this.correspondentieHuisnummerToevoeging = _data["correspondentieHuisnummerToevoeging"];
            this.correspondentieAdresToevoeging = _data["correspondentieAdresToevoeging"];
            this.correspondentiePostcode = _data["correspondentiePostcode"];
            this.correspondentiePlaats = _data["correspondentiePlaats"];
            this.correspondentieEmail = _data["correspondentieEmail"];
            this.correspondentieTelefoon = _data["correspondentieTelefoon"];
            this.correspondentieContact = _data["correspondentieContact"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.bestellijst = _data["bestellijst"] ? Bestellijst.fromJS(_data["bestellijst"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Klant {
        data = typeof data === 'object' ? data : {};
        let result = new Klant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naam"] = this.naam;
        data["voornaam"] = this.voornaam;
        data["tussenvoegsel"] = this.tussenvoegsel;
        data["achternaam"] = this.achternaam;
        data["bedrijfsnaam"] = this.bedrijfsnaam;
        data["volledigeNaam"] = this.volledigeNaam;
        data["adres"] = this.adres;
        data["straat"] = this.straat;
        data["huisnummer"] = this.huisnummer;
        data["huisnummerToevoeging"] = this.huisnummerToevoeging;
        data["adresToevoeging"] = this.adresToevoeging;
        data["postcode"] = this.postcode;
        data["plaats"] = this.plaats;
        data["telefoon"] = this.telefoon;
        data["email"] = this.email;
        data["emailPakbon"] = this.emailPakbon;
        data["emailFactuur"] = this.emailFactuur;
        data["debiteurNummer"] = this.debiteurNummer;
        data["isParticulier"] = this.isParticulier;
        data["isIncassoKlant"] = this.isIncassoKlant;
        data["sendInvoiceDigital"] = this.sendInvoiceDigital;
        data["sendPackingSlipDigital"] = this.sendPackingSlipDigital;
        data["sendOrderConfirmation"] = this.sendOrderConfirmation;
        data["useCorrespondentieAdresForInvoice"] = this.useCorrespondentieAdresForInvoice;
        data["addPaymentLinkToMailTemplate"] = this.addPaymentLinkToMailTemplate;
        data["contactPersoon"] = this.contactPersoon;
        data["contactEmailAdres"] = this.contactEmailAdres;
        data["contactTelefoonnummer"] = this.contactTelefoonnummer;
        data["notitie"] = this.notitie;
        data["correspondentieAdres"] = this.correspondentieAdres;
        data["correspondentieStraat"] = this.correspondentieStraat;
        data["correspondentieHuisnummer"] = this.correspondentieHuisnummer;
        data["correspondentieHuisnummerToevoeging"] = this.correspondentieHuisnummerToevoeging;
        data["correspondentieAdresToevoeging"] = this.correspondentieAdresToevoeging;
        data["correspondentiePostcode"] = this.correspondentiePostcode;
        data["correspondentiePlaats"] = this.correspondentiePlaats;
        data["correspondentieEmail"] = this.correspondentieEmail;
        data["correspondentieTelefoon"] = this.correspondentieTelefoon;
        data["correspondentieContact"] = this.correspondentieContact;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["bestellijst"] = this.bestellijst ? this.bestellijst.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IKlant {
    id?: number;
    naam?: string | undefined;
    voornaam?: string | undefined;
    tussenvoegsel?: string | undefined;
    achternaam?: string | undefined;
    bedrijfsnaam?: string | undefined;
    volledigeNaam?: string | undefined;
    adres?: string | undefined;
    straat?: string | undefined;
    huisnummer?: string | undefined;
    huisnummerToevoeging?: string | undefined;
    adresToevoeging?: string | undefined;
    postcode?: string | undefined;
    plaats?: string | undefined;
    telefoon?: string | undefined;
    email?: string | undefined;
    emailPakbon?: string | undefined;
    emailFactuur?: string | undefined;
    debiteurNummer?: number;
    isParticulier?: boolean;
    isIncassoKlant?: boolean;
    sendInvoiceDigital?: boolean;
    sendPackingSlipDigital?: boolean;
    sendOrderConfirmation?: boolean;
    useCorrespondentieAdresForInvoice?: boolean;
    addPaymentLinkToMailTemplate?: boolean;
    contactPersoon?: string | undefined;
    contactEmailAdres?: string | undefined;
    contactTelefoonnummer?: string | undefined;
    notitie?: string | undefined;
    correspondentieAdres?: string | undefined;
    correspondentieStraat?: string | undefined;
    correspondentieHuisnummer?: string | undefined;
    correspondentieHuisnummerToevoeging?: string | undefined;
    correspondentieAdresToevoeging?: string | undefined;
    correspondentiePostcode?: string | undefined;
    correspondentiePlaats?: string | undefined;
    correspondentieEmail?: string | undefined;
    correspondentieTelefoon?: string | undefined;
    correspondentieContact?: string | undefined;
    deletedOn?: Date | undefined;
    bestellijst?: Bestellijst | undefined;
}

export class Bestellijst implements IBestellijst {
    id?: number;
    opmerking?: string | undefined;
    orderRegels?: BestelLijstRegel[] | undefined;

    constructor(data?: IBestellijst) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.opmerking = _data["opmerking"];
            if (Array.isArray(_data["orderRegels"])) {
                this.orderRegels = [] as any;
                for (let item of _data["orderRegels"])
                    this.orderRegels!.push(BestelLijstRegel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Bestellijst {
        data = typeof data === 'object' ? data : {};
        let result = new Bestellijst();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["opmerking"] = this.opmerking;
        if (Array.isArray(this.orderRegels)) {
            data["orderRegels"] = [];
            for (let item of this.orderRegels)
                data["orderRegels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBestellijst {
    id?: number;
    opmerking?: string | undefined;
    orderRegels?: BestelLijstRegel[] | undefined;
}

export class BestelLijstRegel implements IBestelLijstRegel {
    id?: number;
    omschrijving?: string | undefined;
    aantal?: number;
    opmerking?: string | undefined;
    bestellijstId?: number;
    eenheidId?: number;
    eenheid?: Eenheid | undefined;
    productId?: number;
    product?: Product | undefined;

    constructor(data?: IBestelLijstRegel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.omschrijving = _data["omschrijving"];
            this.aantal = _data["aantal"];
            this.opmerking = _data["opmerking"];
            this.bestellijstId = _data["bestellijstId"];
            this.eenheidId = _data["eenheidId"];
            this.eenheid = _data["eenheid"] ? Eenheid.fromJS(_data["eenheid"]) : <any>undefined;
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BestelLijstRegel {
        data = typeof data === 'object' ? data : {};
        let result = new BestelLijstRegel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["omschrijving"] = this.omschrijving;
        data["aantal"] = this.aantal;
        data["opmerking"] = this.opmerking;
        data["bestellijstId"] = this.bestellijstId;
        data["eenheidId"] = this.eenheidId;
        data["eenheid"] = this.eenheid ? this.eenheid.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IBestelLijstRegel {
    id?: number;
    omschrijving?: string | undefined;
    aantal?: number;
    opmerking?: string | undefined;
    bestellijstId?: number;
    eenheidId?: number;
    eenheid?: Eenheid | undefined;
    productId?: number;
    product?: Product | undefined;
}

export class PakbonRegel implements IPakbonRegel {
    id?: number;
    omschrijving?: string | undefined;
    aantal?: number;
    prijs?: number;
    eenheid?: string | undefined;
    bedrag?: number;
    opmerking?: string | undefined;
    besteld?: string | undefined;
    btw?: number;
    grootboek?: number;
    deletedOn?: Date | undefined;
    voorrraadRegel?: Voorraad | undefined;
    batch?: Batch | undefined;
    batchId?: number | undefined;
    productId?: number;
    pakbonId?: number;
    total?: number;

    constructor(data?: IPakbonRegel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.omschrijving = _data["omschrijving"];
            this.aantal = _data["aantal"];
            this.prijs = _data["prijs"];
            this.eenheid = _data["eenheid"];
            this.bedrag = _data["bedrag"];
            this.opmerking = _data["opmerking"];
            this.besteld = _data["besteld"];
            this.btw = _data["btw"];
            this.grootboek = _data["grootboek"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.voorrraadRegel = _data["voorrraadRegel"] ? Voorraad.fromJS(_data["voorrraadRegel"]) : <any>undefined;
            this.batch = _data["batch"] ? Batch.fromJS(_data["batch"]) : <any>undefined;
            this.batchId = _data["batchId"];
            this.productId = _data["productId"];
            this.pakbonId = _data["pakbonId"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): PakbonRegel {
        data = typeof data === 'object' ? data : {};
        let result = new PakbonRegel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["omschrijving"] = this.omschrijving;
        data["aantal"] = this.aantal;
        data["prijs"] = this.prijs;
        data["eenheid"] = this.eenheid;
        data["bedrag"] = this.bedrag;
        data["opmerking"] = this.opmerking;
        data["besteld"] = this.besteld;
        data["btw"] = this.btw;
        data["grootboek"] = this.grootboek;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["voorrraadRegel"] = this.voorrraadRegel ? this.voorrraadRegel.toJSON() : <any>undefined;
        data["batch"] = this.batch ? this.batch.toJSON() : <any>undefined;
        data["batchId"] = this.batchId;
        data["productId"] = this.productId;
        data["pakbonId"] = this.pakbonId;
        data["total"] = this.total;
        return data; 
    }
}

export interface IPakbonRegel {
    id?: number;
    omschrijving?: string | undefined;
    aantal?: number;
    prijs?: number;
    eenheid?: string | undefined;
    bedrag?: number;
    opmerking?: string | undefined;
    besteld?: string | undefined;
    btw?: number;
    grootboek?: number;
    deletedOn?: Date | undefined;
    voorrraadRegel?: Voorraad | undefined;
    batch?: Batch | undefined;
    batchId?: number | undefined;
    productId?: number;
    pakbonId?: number;
    total?: number;
}

export class Voorraad implements IVoorraad {
    id?: number;
    gewicht?: number;
    product?: Product | undefined;
    batch?: Batch | undefined;
    status?: VoorraadStatus;
    dier?: Dier | undefined;
    mutatieTijd?: Date;

    constructor(data?: IVoorraad) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gewicht = _data["gewicht"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.batch = _data["batch"] ? Batch.fromJS(_data["batch"]) : <any>undefined;
            this.status = _data["status"];
            this.dier = _data["dier"] ? Dier.fromJS(_data["dier"]) : <any>undefined;
            this.mutatieTijd = _data["mutatieTijd"] ? new Date(_data["mutatieTijd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Voorraad {
        data = typeof data === 'object' ? data : {};
        let result = new Voorraad();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gewicht"] = this.gewicht;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["batch"] = this.batch ? this.batch.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["dier"] = this.dier ? this.dier.toJSON() : <any>undefined;
        data["mutatieTijd"] = this.mutatieTijd ? this.mutatieTijd.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IVoorraad {
    id?: number;
    gewicht?: number;
    product?: Product | undefined;
    batch?: Batch | undefined;
    status?: VoorraadStatus;
    dier?: Dier | undefined;
    mutatieTijd?: Date;
}

export enum VoorraadStatus {
    InVoorraad = 0,
    Overschreven = 1,
    Verwerkt = 2,
    InToonbank = 3,
}

export class Verzendlabel implements IVerzendlabel {
    id?: number | undefined;
    type?: ShipmentType;
    barcode?: string | undefined;
    gewicht?: string | undefined;
    straat?: string | undefined;
    huisnummer?: string | undefined;
    huisnummerToevoeging?: string | undefined;
    postcode?: string | undefined;
    plaats?: string | undefined;
    adresToevoeging?: string | undefined;
    klantNaam?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    createdOn?: Date;
    changedOn?: Date;
    deliveredOn?: Date | undefined;
    deletedOn?: Date | undefined;
    pakbonId?: number | undefined;
    verzendBulkId?: number | undefined;
    printCommand?: string | undefined;
    verzendstatussen?: VerzendlabelStatus[] | undefined;

    constructor(data?: IVerzendlabel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.barcode = _data["barcode"];
            this.gewicht = _data["gewicht"];
            this.straat = _data["straat"];
            this.huisnummer = _data["huisnummer"];
            this.huisnummerToevoeging = _data["huisnummerToevoeging"];
            this.postcode = _data["postcode"];
            this.plaats = _data["plaats"];
            this.adresToevoeging = _data["adresToevoeging"];
            this.klantNaam = _data["klantNaam"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.changedOn = _data["changedOn"] ? new Date(_data["changedOn"].toString()) : <any>undefined;
            this.deliveredOn = _data["deliveredOn"] ? new Date(_data["deliveredOn"].toString()) : <any>undefined;
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.pakbonId = _data["pakbonId"];
            this.verzendBulkId = _data["verzendBulkId"];
            this.printCommand = _data["printCommand"];
            if (Array.isArray(_data["verzendstatussen"])) {
                this.verzendstatussen = [] as any;
                for (let item of _data["verzendstatussen"])
                    this.verzendstatussen!.push(VerzendlabelStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Verzendlabel {
        data = typeof data === 'object' ? data : {};
        let result = new Verzendlabel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["barcode"] = this.barcode;
        data["gewicht"] = this.gewicht;
        data["straat"] = this.straat;
        data["huisnummer"] = this.huisnummer;
        data["huisnummerToevoeging"] = this.huisnummerToevoeging;
        data["postcode"] = this.postcode;
        data["plaats"] = this.plaats;
        data["adresToevoeging"] = this.adresToevoeging;
        data["klantNaam"] = this.klantNaam;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["changedOn"] = this.changedOn ? this.changedOn.toISOString() : <any>undefined;
        data["deliveredOn"] = this.deliveredOn ? this.deliveredOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["pakbonId"] = this.pakbonId;
        data["verzendBulkId"] = this.verzendBulkId;
        data["printCommand"] = this.printCommand;
        if (Array.isArray(this.verzendstatussen)) {
            data["verzendstatussen"] = [];
            for (let item of this.verzendstatussen)
                data["verzendstatussen"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IVerzendlabel {
    id?: number | undefined;
    type?: ShipmentType;
    barcode?: string | undefined;
    gewicht?: string | undefined;
    straat?: string | undefined;
    huisnummer?: string | undefined;
    huisnummerToevoeging?: string | undefined;
    postcode?: string | undefined;
    plaats?: string | undefined;
    adresToevoeging?: string | undefined;
    klantNaam?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    createdOn?: Date;
    changedOn?: Date;
    deliveredOn?: Date | undefined;
    deletedOn?: Date | undefined;
    pakbonId?: number | undefined;
    verzendBulkId?: number | undefined;
    printCommand?: string | undefined;
    verzendstatussen?: VerzendlabelStatus[] | undefined;
}

export class VerzendlabelStatus implements IVerzendlabelStatus {
    id?: number;
    statusCode?: number;
    updateTijd?: Date;
    verzendlabelBarcode?: string | undefined;

    constructor(data?: IVerzendlabelStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusCode = _data["statusCode"];
            this.updateTijd = _data["updateTijd"] ? new Date(_data["updateTijd"].toString()) : <any>undefined;
            this.verzendlabelBarcode = _data["verzendlabelBarcode"];
        }
    }

    static fromJS(data: any): VerzendlabelStatus {
        data = typeof data === 'object' ? data : {};
        let result = new VerzendlabelStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusCode"] = this.statusCode;
        data["updateTijd"] = this.updateTijd ? this.updateTijd.toISOString() : <any>undefined;
        data["verzendlabelBarcode"] = this.verzendlabelBarcode;
        return data; 
    }
}

export interface IVerzendlabelStatus {
    id?: number;
    statusCode?: number;
    updateTijd?: Date;
    verzendlabelBarcode?: string | undefined;
}

export class Factuur implements IFactuur {
    id?: number;
    factuurNummer?: number;
    factuurAanmaakDatum?: Date;
    factuurDatum?: Date;
    klantId?: number;
    isExported?: boolean;
    isPaid?: boolean;
    isPaidWithMollie?: boolean;
    publicIdentifier?: string;
    mailIdentifier?: string;
    klant?: Klant | undefined;
    payments?: Betaling[] | undefined;

    constructor(data?: IFactuur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.factuurNummer = _data["factuurNummer"];
            this.factuurAanmaakDatum = _data["factuurAanmaakDatum"] ? new Date(_data["factuurAanmaakDatum"].toString()) : <any>undefined;
            this.factuurDatum = _data["factuurDatum"] ? new Date(_data["factuurDatum"].toString()) : <any>undefined;
            this.klantId = _data["klantId"];
            this.isExported = _data["isExported"];
            this.isPaid = _data["isPaid"];
            this.isPaidWithMollie = _data["isPaidWithMollie"];
            this.publicIdentifier = _data["publicIdentifier"];
            this.mailIdentifier = _data["mailIdentifier"];
            this.klant = _data["klant"] ? Klant.fromJS(_data["klant"]) : <any>undefined;
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(Betaling.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Factuur {
        data = typeof data === 'object' ? data : {};
        let result = new Factuur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["factuurNummer"] = this.factuurNummer;
        data["factuurAanmaakDatum"] = this.factuurAanmaakDatum ? this.factuurAanmaakDatum.toISOString() : <any>undefined;
        data["factuurDatum"] = this.factuurDatum ? this.factuurDatum.toISOString() : <any>undefined;
        data["klantId"] = this.klantId;
        data["isExported"] = this.isExported;
        data["isPaid"] = this.isPaid;
        data["isPaidWithMollie"] = this.isPaidWithMollie;
        data["publicIdentifier"] = this.publicIdentifier;
        data["mailIdentifier"] = this.mailIdentifier;
        data["klant"] = this.klant ? this.klant.toJSON() : <any>undefined;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFactuur {
    id?: number;
    factuurNummer?: number;
    factuurAanmaakDatum?: Date;
    factuurDatum?: Date;
    klantId?: number;
    isExported?: boolean;
    isPaid?: boolean;
    isPaidWithMollie?: boolean;
    publicIdentifier?: string;
    mailIdentifier?: string;
    klant?: Klant | undefined;
    payments?: Betaling[] | undefined;
}

export class Betaling implements IBetaling {
    id?: string | undefined;
    status?: BetalingStatus;
    factuurId?: number;
    startPaymentDate?: Date;

    constructor(data?: IBetaling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.factuurId = _data["factuurId"];
            this.startPaymentDate = _data["startPaymentDate"] ? new Date(_data["startPaymentDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Betaling {
        data = typeof data === 'object' ? data : {};
        let result = new Betaling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["factuurId"] = this.factuurId;
        data["startPaymentDate"] = this.startPaymentDate ? this.startPaymentDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IBetaling {
    id?: string | undefined;
    status?: BetalingStatus;
    factuurId?: number;
    startPaymentDate?: Date;
}

export enum BetalingStatus {
    Open = 0,
    Canceld = 1,
    Pending = 2,
    Authorized = 3,
    Expired = 4,
    Failed = 5,
    Paid = 6,
}

export class PakbonArchiefDto implements IPakbonArchiefDto {
    selector?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    idFrom?: number;
    idTo?: number;
    custumer?: number;

    constructor(data?: IPakbonArchiefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selector = _data["selector"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.idFrom = _data["idFrom"];
            this.idTo = _data["idTo"];
            this.custumer = _data["custumer"];
        }
    }

    static fromJS(data: any): PakbonArchiefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PakbonArchiefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selector"] = this.selector;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["idFrom"] = this.idFrom;
        data["idTo"] = this.idTo;
        data["custumer"] = this.custumer;
        return data; 
    }
}

export interface IPakbonArchiefDto {
    selector?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    idFrom?: number;
    idTo?: number;
    custumer?: number;
}

export class InvoiceMailResponse implements IInvoiceMailResponse {
    adres?: string | undefined;
    invoice?: number;

    constructor(data?: IInvoiceMailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adres = _data["adres"];
            this.invoice = _data["invoice"];
        }
    }

    static fromJS(data: any): InvoiceMailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceMailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adres"] = this.adres;
        data["invoice"] = this.invoice;
        return data; 
    }
}

export interface IInvoiceMailResponse {
    adres?: string | undefined;
    invoice?: number;
}

export class InvoiceStatusResponse implements IInvoiceStatusResponse {
    message?: string | undefined;
    status?: InvoiceStatus;

    constructor(data?: IInvoiceStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): InvoiceStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["status"] = this.status;
        return data; 
    }
}

export interface IInvoiceStatusResponse {
    message?: string | undefined;
    status?: InvoiceStatus;
}

export enum InvoiceStatus {
    Created = 0,
    Error = 1,
    Warning = 2,
    NullInvoce = 3,
}

export class PushToSnelStartResponse implements IPushToSnelStartResponse {
    isSucceded?: boolean;
    invoiceNumber?: number;
    message?: string | undefined;

    constructor(data?: IPushToSnelStartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSucceded = _data["isSucceded"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PushToSnelStartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PushToSnelStartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSucceded"] = this.isSucceded;
        data["invoiceNumber"] = this.invoiceNumber;
        data["message"] = this.message;
        return data; 
    }
}

export interface IPushToSnelStartResponse {
    isSucceded?: boolean;
    invoiceNumber?: number;
    message?: string | undefined;
}

export class ResendOutstandingInvoicesRequest implements IResendOutstandingInvoicesRequest {
    facturen?: Factuur[] | undefined;
    mailText?: string | undefined;
    subject?: string | undefined;

    constructor(data?: IResendOutstandingInvoicesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["facturen"])) {
                this.facturen = [] as any;
                for (let item of _data["facturen"])
                    this.facturen!.push(Factuur.fromJS(item));
            }
            this.mailText = _data["mailText"];
            this.subject = _data["subject"];
        }
    }

    static fromJS(data: any): ResendOutstandingInvoicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResendOutstandingInvoicesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.facturen)) {
            data["facturen"] = [];
            for (let item of this.facturen)
                data["facturen"].push(item.toJSON());
        }
        data["mailText"] = this.mailText;
        data["subject"] = this.subject;
        return data; 
    }
}

export interface IResendOutstandingInvoicesRequest {
    facturen?: Factuur[] | undefined;
    mailText?: string | undefined;
    subject?: string | undefined;
}

export class RegisterBusinessRelationRequest implements IRegisterBusinessRelationRequest {
    companyName?: string | undefined;
    emailAddress?: string | undefined;
    phonenumber?: string | undefined;
    contactPerson?: string | undefined;
    contactEmailAddress?: string | undefined;
    contactPhoneNumber?: string | undefined;
    street?: string | undefined;
    houseNumber?: number;
    houseNumberAddition?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    comment?: string | undefined;

    constructor(data?: IRegisterBusinessRelationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.emailAddress = _data["emailAddress"];
            this.phonenumber = _data["phonenumber"];
            this.contactPerson = _data["contactPerson"];
            this.contactEmailAddress = _data["contactEmailAddress"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.houseNumberAddition = _data["houseNumberAddition"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): RegisterBusinessRelationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterBusinessRelationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["emailAddress"] = this.emailAddress;
        data["phonenumber"] = this.phonenumber;
        data["contactPerson"] = this.contactPerson;
        data["contactEmailAddress"] = this.contactEmailAddress;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["houseNumberAddition"] = this.houseNumberAddition;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["comment"] = this.comment;
        return data; 
    }
}

export interface IRegisterBusinessRelationRequest {
    companyName?: string | undefined;
    emailAddress?: string | undefined;
    phonenumber?: string | undefined;
    contactPerson?: string | undefined;
    contactEmailAddress?: string | undefined;
    contactPhoneNumber?: string | undefined;
    street?: string | undefined;
    houseNumber?: number;
    houseNumberAddition?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    comment?: string | undefined;
}

export class SnelStartCustomerSearchResponse implements ISnelStartCustomerSearchResponse {
    customers?: SnelStartCustomer[] | undefined;

    constructor(data?: ISnelStartCustomerSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(SnelStartCustomer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SnelStartCustomerSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SnelStartCustomerSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISnelStartCustomerSearchResponse {
    customers?: SnelStartCustomer[] | undefined;
}

export class SnelStartCustomer implements ISnelStartCustomer {
    snelStartId?: string;
    name?: string | undefined;
    relationNumber?: number;
    incassoSoort?: string | undefined;

    constructor(data?: ISnelStartCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.snelStartId = _data["snelStartId"];
            this.name = _data["name"];
            this.relationNumber = _data["relationNumber"];
            this.incassoSoort = _data["incassoSoort"];
        }
    }

    static fromJS(data: any): SnelStartCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new SnelStartCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["snelStartId"] = this.snelStartId;
        data["name"] = this.name;
        data["relationNumber"] = this.relationNumber;
        data["incassoSoort"] = this.incassoSoort;
        return data; 
    }
}

export interface ISnelStartCustomer {
    snelStartId?: string;
    name?: string | undefined;
    relationNumber?: number;
    incassoSoort?: string | undefined;
}

export class GetMailStatusByCustomerResponse implements IGetMailStatusByCustomerResponse {
    mailStatus?: GroupedMailStatus[] | undefined;

    constructor(data?: IGetMailStatusByCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mailStatus"])) {
                this.mailStatus = [] as any;
                for (let item of _data["mailStatus"])
                    this.mailStatus!.push(GroupedMailStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMailStatusByCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMailStatusByCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mailStatus)) {
            data["mailStatus"] = [];
            for (let item of this.mailStatus)
                data["mailStatus"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetMailStatusByCustomerResponse {
    mailStatus?: GroupedMailStatus[] | undefined;
}

export class GroupedMailStatus implements IGroupedMailStatus {
    mailIdentifier?: string;
    latestStatus?: MailStatus | undefined;
    mailStatus?: MailStatus[] | undefined;

    constructor(data?: IGroupedMailStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailIdentifier = _data["mailIdentifier"];
            this.latestStatus = _data["latestStatus"] ? MailStatus.fromJS(_data["latestStatus"]) : <any>undefined;
            if (Array.isArray(_data["mailStatus"])) {
                this.mailStatus = [] as any;
                for (let item of _data["mailStatus"])
                    this.mailStatus!.push(MailStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupedMailStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedMailStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailIdentifier"] = this.mailIdentifier;
        data["latestStatus"] = this.latestStatus ? this.latestStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.mailStatus)) {
            data["mailStatus"] = [];
            for (let item of this.mailStatus)
                data["mailStatus"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGroupedMailStatus {
    mailIdentifier?: string;
    latestStatus?: MailStatus | undefined;
    mailStatus?: MailStatus[] | undefined;
}

export class MailStatus implements IMailStatus {
    id?: number;
    mailIdentifier?: string;
    status?: string | undefined;
    time?: Date;
    klantId?: number | undefined;
    subject?: string | undefined;
    mailAddress?: string | undefined;
    klant?: Klant | undefined;

    constructor(data?: IMailStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mailIdentifier = _data["mailIdentifier"];
            this.status = _data["status"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.klantId = _data["klantId"];
            this.subject = _data["subject"];
            this.mailAddress = _data["mailAddress"];
            this.klant = _data["klant"] ? Klant.fromJS(_data["klant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MailStatus {
        data = typeof data === 'object' ? data : {};
        let result = new MailStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mailIdentifier"] = this.mailIdentifier;
        data["status"] = this.status;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["klantId"] = this.klantId;
        data["subject"] = this.subject;
        data["mailAddress"] = this.mailAddress;
        data["klant"] = this.klant ? this.klant.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMailStatus {
    id?: number;
    mailIdentifier?: string;
    status?: string | undefined;
    time?: Date;
    klantId?: number | undefined;
    subject?: string | undefined;
    mailAddress?: string | undefined;
    klant?: Klant | undefined;
}

export class LoggingModel implements ILoggingModel {
    exception?: string | undefined;
    eventId?: string | undefined;

    constructor(data?: ILoggingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exception = _data["exception"];
            this.eventId = _data["eventId"];
        }
    }

    static fromJS(data: any): LoggingModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoggingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exception"] = this.exception;
        data["eventId"] = this.eventId;
        return data; 
    }
}

export interface ILoggingModel {
    exception?: string | undefined;
    eventId?: string | undefined;
}

export class CreateOrderRequest implements ICreateOrderRequest {
    order?: Order | undefined;
    createAccount?: boolean;
    password?: string | undefined;

    constructor(data?: ICreateOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.createAccount = _data["createAccount"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["createAccount"] = this.createAccount;
        data["password"] = this.password;
        return data; 
    }
}

export interface ICreateOrderRequest {
    order?: Order | undefined;
    createAccount?: boolean;
    password?: string | undefined;
}

export class AddProductToList implements IAddProductToList {
    bestellijstId?: number;
    productId?: number;
    eenheidId?: number;
    aantal?: number;
    opmerking?: string | undefined;
    omschrijving?: string | undefined;

    constructor(data?: IAddProductToList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bestellijstId = _data["bestellijstId"];
            this.productId = _data["productId"];
            this.eenheidId = _data["eenheidId"];
            this.aantal = _data["aantal"];
            this.opmerking = _data["opmerking"];
            this.omschrijving = _data["omschrijving"];
        }
    }

    static fromJS(data: any): AddProductToList {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductToList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bestellijstId"] = this.bestellijstId;
        data["productId"] = this.productId;
        data["eenheidId"] = this.eenheidId;
        data["aantal"] = this.aantal;
        data["opmerking"] = this.opmerking;
        data["omschrijving"] = this.omschrijving;
        return data; 
    }
}

export interface IAddProductToList {
    bestellijstId?: number;
    productId?: number;
    eenheidId?: number;
    aantal?: number;
    opmerking?: string | undefined;
    omschrijving?: string | undefined;
}

export class PackingslipMailResponse implements IPackingslipMailResponse {
    adres?: string | undefined;
    packingslip?: number;

    constructor(data?: IPackingslipMailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adres = _data["adres"];
            this.packingslip = _data["packingslip"];
        }
    }

    static fromJS(data: any): PackingslipMailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PackingslipMailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adres"] = this.adres;
        data["packingslip"] = this.packingslip;
        return data; 
    }
}

export interface IPackingslipMailResponse {
    adres?: string | undefined;
    packingslip?: number;
}

export class PrintLabelViewModel implements IPrintLabelViewModel {
    pakbonRegel?: PakbonRegel | undefined;
    thtDate?: Date;
    count?: number;

    constructor(data?: IPrintLabelViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pakbonRegel = _data["pakbonRegel"] ? PakbonRegel.fromJS(_data["pakbonRegel"]) : <any>undefined;
            this.thtDate = _data["thtDate"] ? new Date(_data["thtDate"].toString()) : <any>undefined;
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): PrintLabelViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PrintLabelViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pakbonRegel"] = this.pakbonRegel ? this.pakbonRegel.toJSON() : <any>undefined;
        data["thtDate"] = this.thtDate ? this.thtDate.toISOString() : <any>undefined;
        data["count"] = this.count;
        return data; 
    }
}

export interface IPrintLabelViewModel {
    pakbonRegel?: PakbonRegel | undefined;
    thtDate?: Date;
    count?: number;
}

export class GetPriceListRequest implements IGetPriceListRequest {
    productGroupIds?: number[] | undefined;

    constructor(data?: IGetPriceListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productGroupIds"])) {
                this.productGroupIds = [] as any;
                for (let item of _data["productGroupIds"])
                    this.productGroupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPriceListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPriceListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productGroupIds)) {
            data["productGroupIds"] = [];
            for (let item of this.productGroupIds)
                data["productGroupIds"].push(item);
        }
        return data; 
    }
}

export interface IGetPriceListRequest {
    productGroupIds?: number[] | undefined;
}

export class ProductMutatie implements IProductMutatie {
    id?: number;
    naam?: string | undefined;
    consumentPrijs?: number;
    horecaPrijs?: number;
    ingredienten?: string | undefined;
    opSite?: boolean;
    deletedOn?: Date | undefined;
    parentProduct?: Product | undefined;
    standaardEenheid?: Eenheid | undefined;
    btw?: Btw | undefined;

    constructor(data?: IProductMutatie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naam = _data["naam"];
            this.consumentPrijs = _data["consumentPrijs"];
            this.horecaPrijs = _data["horecaPrijs"];
            this.ingredienten = _data["ingredienten"];
            this.opSite = _data["opSite"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.parentProduct = _data["parentProduct"] ? Product.fromJS(_data["parentProduct"]) : <any>undefined;
            this.standaardEenheid = _data["standaardEenheid"] ? Eenheid.fromJS(_data["standaardEenheid"]) : <any>undefined;
            this.btw = _data["btw"] ? Btw.fromJS(_data["btw"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductMutatie {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMutatie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naam"] = this.naam;
        data["consumentPrijs"] = this.consumentPrijs;
        data["horecaPrijs"] = this.horecaPrijs;
        data["ingredienten"] = this.ingredienten;
        data["opSite"] = this.opSite;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["parentProduct"] = this.parentProduct ? this.parentProduct.toJSON() : <any>undefined;
        data["standaardEenheid"] = this.standaardEenheid ? this.standaardEenheid.toJSON() : <any>undefined;
        data["btw"] = this.btw ? this.btw.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IProductMutatie {
    id?: number;
    naam?: string | undefined;
    consumentPrijs?: number;
    horecaPrijs?: number;
    ingredienten?: string | undefined;
    opSite?: boolean;
    deletedOn?: Date | undefined;
    parentProduct?: Product | undefined;
    standaardEenheid?: Eenheid | undefined;
    btw?: Btw | undefined;
}

export class PushSubscriptionModel implements IPushSubscriptionModel {
    endpoint?: string | undefined;
    expirationTime?: string | undefined;
    keys?: Keys | undefined;

    constructor(data?: IPushSubscriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endpoint = _data["endpoint"];
            this.expirationTime = _data["expirationTime"];
            this.keys = _data["keys"] ? Keys.fromJS(_data["keys"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PushSubscriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushSubscriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endpoint"] = this.endpoint;
        data["expirationTime"] = this.expirationTime;
        data["keys"] = this.keys ? this.keys.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPushSubscriptionModel {
    endpoint?: string | undefined;
    expirationTime?: string | undefined;
    keys?: Keys | undefined;
}

export class Keys implements IKeys {
    p256dh?: string | undefined;
    auth?: string | undefined;

    constructor(data?: IKeys) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.p256dh = _data["p256dh"];
            this.auth = _data["auth"];
        }
    }

    static fromJS(data: any): Keys {
        data = typeof data === 'object' ? data : {};
        let result = new Keys();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["p256dh"] = this.p256dh;
        data["auth"] = this.auth;
        return data; 
    }
}

export interface IKeys {
    p256dh?: string | undefined;
    auth?: string | undefined;
}

export class UnsubscribeDeviceRequest implements IUnsubscribeDeviceRequest {
    endpoint?: string | undefined;

    constructor(data?: IUnsubscribeDeviceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endpoint = _data["endpoint"];
        }
    }

    static fromJS(data: any): UnsubscribeDeviceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnsubscribeDeviceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endpoint"] = this.endpoint;
        return data; 
    }
}

export interface IUnsubscribeDeviceRequest {
    endpoint?: string | undefined;
}

export class OmzetResultDto implements IOmzetResultDto {
    omzetResults?: OmzetResultsListDto[] | undefined;
    van?: Date;
    tot?: Date;
    totalOmzet?: number;
    totalBrutoWinst?: number;

    constructor(data?: IOmzetResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["omzetResults"])) {
                this.omzetResults = [] as any;
                for (let item of _data["omzetResults"])
                    this.omzetResults!.push(OmzetResultsListDto.fromJS(item));
            }
            this.van = _data["van"] ? new Date(_data["van"].toString()) : <any>undefined;
            this.tot = _data["tot"] ? new Date(_data["tot"].toString()) : <any>undefined;
            this.totalOmzet = _data["totalOmzet"];
            this.totalBrutoWinst = _data["totalBrutoWinst"];
        }
    }

    static fromJS(data: any): OmzetResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OmzetResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.omzetResults)) {
            data["omzetResults"] = [];
            for (let item of this.omzetResults)
                data["omzetResults"].push(item.toJSON());
        }
        data["van"] = this.van ? this.van.toISOString() : <any>undefined;
        data["tot"] = this.tot ? this.tot.toISOString() : <any>undefined;
        data["totalOmzet"] = this.totalOmzet;
        data["totalBrutoWinst"] = this.totalBrutoWinst;
        return data; 
    }
}

export interface IOmzetResultDto {
    omzetResults?: OmzetResultsListDto[] | undefined;
    van?: Date;
    tot?: Date;
    totalOmzet?: number;
    totalBrutoWinst?: number;
}

export class OmzetResultsListDto implements IOmzetResultsListDto {
    omschrijving?: string | undefined;
    internalNumber?: string | undefined;
    aantal?: number;
    eenheid?: string | undefined;
    omzet?: number;
    brutoWinst?: number;

    constructor(data?: IOmzetResultsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.omschrijving = _data["omschrijving"];
            this.internalNumber = _data["internalNumber"];
            this.aantal = _data["aantal"];
            this.eenheid = _data["eenheid"];
            this.omzet = _data["omzet"];
            this.brutoWinst = _data["brutoWinst"];
        }
    }

    static fromJS(data: any): OmzetResultsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OmzetResultsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["omschrijving"] = this.omschrijving;
        data["internalNumber"] = this.internalNumber;
        data["aantal"] = this.aantal;
        data["eenheid"] = this.eenheid;
        data["omzet"] = this.omzet;
        data["brutoWinst"] = this.brutoWinst;
        return data; 
    }
}

export interface IOmzetResultsListDto {
    omschrijving?: string | undefined;
    internalNumber?: string | undefined;
    aantal?: number;
    eenheid?: string | undefined;
    omzet?: number;
    brutoWinst?: number;
}

export class ReportSelectieDto implements IReportSelectieDto {
    reportType?: SelectedReportType;
    omschrijving?: string | undefined;
    id?: number | undefined;
    selectAl?: boolean;
    van?: Date;
    tot?: Date;

    constructor(data?: IReportSelectieDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportType = _data["reportType"];
            this.omschrijving = _data["omschrijving"];
            this.id = _data["id"];
            this.selectAl = _data["selectAl"];
            this.van = _data["van"] ? new Date(_data["van"].toString()) : <any>undefined;
            this.tot = _data["tot"] ? new Date(_data["tot"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportSelectieDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSelectieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportType"] = this.reportType;
        data["omschrijving"] = this.omschrijving;
        data["id"] = this.id;
        data["selectAl"] = this.selectAl;
        data["van"] = this.van ? this.van.toISOString() : <any>undefined;
        data["tot"] = this.tot ? this.tot.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IReportSelectieDto {
    reportType?: SelectedReportType;
    omschrijving?: string | undefined;
    id?: number | undefined;
    selectAl?: boolean;
    van?: Date;
    tot?: Date;
}

export enum SelectedReportType {
    Klant = 1,
    Grootboek = 2,
    Product = 3,
}

export class ScanningBatchResultDto implements IScanningBatchResultDto {
    dier?: Dier | undefined;
    isNewBadge?: boolean;
    isNewAnimal?: boolean;
    externalId?: number;
    famerNotExist?: boolean;

    constructor(data?: IScanningBatchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dier = _data["dier"] ? Dier.fromJS(_data["dier"]) : <any>undefined;
            this.isNewBadge = _data["isNewBadge"];
            this.isNewAnimal = _data["isNewAnimal"];
            this.externalId = _data["externalId"];
            this.famerNotExist = _data["famerNotExist"];
        }
    }

    static fromJS(data: any): ScanningBatchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScanningBatchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dier"] = this.dier ? this.dier.toJSON() : <any>undefined;
        data["isNewBadge"] = this.isNewBadge;
        data["isNewAnimal"] = this.isNewAnimal;
        data["externalId"] = this.externalId;
        data["famerNotExist"] = this.famerNotExist;
        return data; 
    }
}

export interface IScanningBatchResultDto {
    dier?: Dier | undefined;
    isNewBadge?: boolean;
    isNewAnimal?: boolean;
    externalId?: number;
    famerNotExist?: boolean;
}

export class AddManualAnimalDto implements IAddManualAnimalDto {
    slachtdatum?: Date;
    volgnummer?: number;
    dierNummer?: string | undefined;
    boer?: Boer | undefined;
    leverancier?: Leverancier | undefined;
    ras?: Ras | undefined;
    soort?: DierSoort | undefined;

    constructor(data?: IAddManualAnimalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.slachtdatum = _data["slachtdatum"] ? new Date(_data["slachtdatum"].toString()) : <any>undefined;
            this.volgnummer = _data["volgnummer"];
            this.dierNummer = _data["dierNummer"];
            this.boer = _data["boer"] ? Boer.fromJS(_data["boer"]) : <any>undefined;
            this.leverancier = _data["leverancier"] ? Leverancier.fromJS(_data["leverancier"]) : <any>undefined;
            this.ras = _data["ras"] ? Ras.fromJS(_data["ras"]) : <any>undefined;
            this.soort = _data["soort"] ? DierSoort.fromJS(_data["soort"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddManualAnimalDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddManualAnimalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slachtdatum"] = this.slachtdatum ? this.slachtdatum.toISOString() : <any>undefined;
        data["volgnummer"] = this.volgnummer;
        data["dierNummer"] = this.dierNummer;
        data["boer"] = this.boer ? this.boer.toJSON() : <any>undefined;
        data["leverancier"] = this.leverancier ? this.leverancier.toJSON() : <any>undefined;
        data["ras"] = this.ras ? this.ras.toJSON() : <any>undefined;
        data["soort"] = this.soort ? this.soort.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddManualAnimalDto {
    slachtdatum?: Date;
    volgnummer?: number;
    dierNummer?: string | undefined;
    boer?: Boer | undefined;
    leverancier?: Leverancier | undefined;
    ras?: Ras | undefined;
    soort?: DierSoort | undefined;
}

export class Settings implements ISettings {
    id?: number;
    factuurnummer?: number;
    pakbonMailTekst?: string | undefined;
    orderMailTekst?: string | undefined;
    labelPrinter?: string | undefined;
    baudRateLabelPrinter?: number;
    bonPrinter?: string | undefined;
    baudRateBonPrinter?: number;
    weegschaal?: string | undefined;
    environment?: string | undefined;
    snelStartApiKey?: string | undefined;
    invoiceLogo?: string | undefined;
    postnlApiKey?: string | undefined;
    myParcelApiKey?: string | undefined;
    shipmentProvider?: ShipmentProvider;
    postnlCustomerCode?: string | undefined;
    postnlCustomerNumber?: string | undefined;
    postnlLocationCode?: string | undefined;
    mollieApiKey?: string | undefined;

    constructor(data?: ISettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.factuurnummer = _data["factuurnummer"];
            this.pakbonMailTekst = _data["pakbonMailTekst"];
            this.orderMailTekst = _data["orderMailTekst"];
            this.labelPrinter = _data["labelPrinter"];
            this.baudRateLabelPrinter = _data["baudRateLabelPrinter"];
            this.bonPrinter = _data["bonPrinter"];
            this.baudRateBonPrinter = _data["baudRateBonPrinter"];
            this.weegschaal = _data["weegschaal"];
            this.environment = _data["environment"];
            this.snelStartApiKey = _data["snelStartApiKey"];
            this.invoiceLogo = _data["invoiceLogo"];
            this.postnlApiKey = _data["postnlApiKey"];
            this.myParcelApiKey = _data["myParcelApiKey"];
            this.shipmentProvider = _data["shipmentProvider"];
            this.postnlCustomerCode = _data["postnlCustomerCode"];
            this.postnlCustomerNumber = _data["postnlCustomerNumber"];
            this.postnlLocationCode = _data["postnlLocationCode"];
            this.mollieApiKey = _data["mollieApiKey"];
        }
    }

    static fromJS(data: any): Settings {
        data = typeof data === 'object' ? data : {};
        let result = new Settings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["factuurnummer"] = this.factuurnummer;
        data["pakbonMailTekst"] = this.pakbonMailTekst;
        data["orderMailTekst"] = this.orderMailTekst;
        data["labelPrinter"] = this.labelPrinter;
        data["baudRateLabelPrinter"] = this.baudRateLabelPrinter;
        data["bonPrinter"] = this.bonPrinter;
        data["baudRateBonPrinter"] = this.baudRateBonPrinter;
        data["weegschaal"] = this.weegschaal;
        data["environment"] = this.environment;
        data["snelStartApiKey"] = this.snelStartApiKey;
        data["invoiceLogo"] = this.invoiceLogo;
        data["postnlApiKey"] = this.postnlApiKey;
        data["myParcelApiKey"] = this.myParcelApiKey;
        data["shipmentProvider"] = this.shipmentProvider;
        data["postnlCustomerCode"] = this.postnlCustomerCode;
        data["postnlCustomerNumber"] = this.postnlCustomerNumber;
        data["postnlLocationCode"] = this.postnlLocationCode;
        data["mollieApiKey"] = this.mollieApiKey;
        return data; 
    }
}

export interface ISettings {
    id?: number;
    factuurnummer?: number;
    pakbonMailTekst?: string | undefined;
    orderMailTekst?: string | undefined;
    labelPrinter?: string | undefined;
    baudRateLabelPrinter?: number;
    bonPrinter?: string | undefined;
    baudRateBonPrinter?: number;
    weegschaal?: string | undefined;
    environment?: string | undefined;
    snelStartApiKey?: string | undefined;
    invoiceLogo?: string | undefined;
    postnlApiKey?: string | undefined;
    myParcelApiKey?: string | undefined;
    shipmentProvider?: ShipmentProvider;
    postnlCustomerCode?: string | undefined;
    postnlCustomerNumber?: string | undefined;
    postnlLocationCode?: string | undefined;
    mollieApiKey?: string | undefined;
}

export enum ShipmentProvider {
    PostNl = 0,
    MyParcel = 1,
}

export class GetMailHistoryResponse implements IGetMailHistoryResponse {
    from?: Date | undefined;
    to?: Date | undefined;
    mailStatuses?: GroupedMailStatus2[] | undefined;

    constructor(data?: IGetMailHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            if (Array.isArray(_data["mailStatuses"])) {
                this.mailStatuses = [] as any;
                for (let item of _data["mailStatuses"])
                    this.mailStatuses!.push(GroupedMailStatus2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMailHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMailHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (Array.isArray(this.mailStatuses)) {
            data["mailStatuses"] = [];
            for (let item of this.mailStatuses)
                data["mailStatuses"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetMailHistoryResponse {
    from?: Date | undefined;
    to?: Date | undefined;
    mailStatuses?: GroupedMailStatus2[] | undefined;
}

export class GroupedMailStatus2 implements IGroupedMailStatus2 {
    mailIdentifier?: string;
    latestStatus?: MailStatus | undefined;
    mailStatus?: MailStatus[] | undefined;

    constructor(data?: IGroupedMailStatus2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailIdentifier = _data["mailIdentifier"];
            this.latestStatus = _data["latestStatus"] ? MailStatus.fromJS(_data["latestStatus"]) : <any>undefined;
            if (Array.isArray(_data["mailStatus"])) {
                this.mailStatus = [] as any;
                for (let item of _data["mailStatus"])
                    this.mailStatus!.push(MailStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupedMailStatus2 {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedMailStatus2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailIdentifier"] = this.mailIdentifier;
        data["latestStatus"] = this.latestStatus ? this.latestStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.mailStatus)) {
            data["mailStatus"] = [];
            for (let item of this.mailStatus)
                data["mailStatus"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGroupedMailStatus2 {
    mailIdentifier?: string;
    latestStatus?: MailStatus | undefined;
    mailStatus?: MailStatus[] | undefined;
}

export class GetMailHistoryRequest implements IGetMailHistoryRequest {
    from?: Date | undefined;
    to?: Date | undefined;

    constructor(data?: IGetMailHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMailHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMailHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetMailHistoryRequest {
    from?: Date | undefined;
    to?: Date | undefined;
}

export class Gebruiker implements IGebruiker {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    picture?: string | undefined;
    printEnvironment?: string | undefined;
    bonPrinter?: string | undefined;
    labelPrinter?: string | undefined;
    weegschaal?: string | undefined;
    klant?: Klant | undefined;

    constructor(data?: IGebruiker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.picture = _data["picture"];
            this.printEnvironment = _data["printEnvironment"];
            this.bonPrinter = _data["bonPrinter"];
            this.labelPrinter = _data["labelPrinter"];
            this.weegschaal = _data["weegschaal"];
            this.klant = _data["klant"] ? Klant.fromJS(_data["klant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Gebruiker {
        data = typeof data === 'object' ? data : {};
        let result = new Gebruiker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["picture"] = this.picture;
        data["printEnvironment"] = this.printEnvironment;
        data["bonPrinter"] = this.bonPrinter;
        data["labelPrinter"] = this.labelPrinter;
        data["weegschaal"] = this.weegschaal;
        data["klant"] = this.klant ? this.klant.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGebruiker {
    id?: string;
    name?: string | undefined;
    email?: string | undefined;
    picture?: string | undefined;
    printEnvironment?: string | undefined;
    bonPrinter?: string | undefined;
    labelPrinter?: string | undefined;
    weegschaal?: string | undefined;
    klant?: Klant | undefined;
}

export class GroupedVerzendLabel implements IGroupedVerzendLabel {
    label?: Verzendlabel | undefined;
    latestStatus?: VerzendlabelStatus | undefined;

    constructor(data?: IGroupedVerzendLabel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"] ? Verzendlabel.fromJS(_data["label"]) : <any>undefined;
            this.latestStatus = _data["latestStatus"] ? VerzendlabelStatus.fromJS(_data["latestStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GroupedVerzendLabel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedVerzendLabel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label ? this.label.toJSON() : <any>undefined;
        data["latestStatus"] = this.latestStatus ? this.latestStatus.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGroupedVerzendLabel {
    label?: Verzendlabel | undefined;
    latestStatus?: VerzendlabelStatus | undefined;
}

export class PostnlBarcodeShipmentStatusResponse implements IPostnlBarcodeShipmentStatusResponse {
    completeStatus?: Test | undefined;

    constructor(data?: IPostnlBarcodeShipmentStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completeStatus = _data["completeStatus"] ? Test.fromJS(_data["completeStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PostnlBarcodeShipmentStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PostnlBarcodeShipmentStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completeStatus"] = this.completeStatus ? this.completeStatus.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPostnlBarcodeShipmentStatusResponse {
    completeStatus?: Test | undefined;
}

export class Test implements ITest {
    shipment?: Shipment | undefined;

    constructor(data?: ITest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipment = _data["shipment"] ? Shipment.fromJS(_data["shipment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Test {
        data = typeof data === 'object' ? data : {};
        let result = new Test();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipment"] = this.shipment ? this.shipment.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITest {
    shipment?: Shipment | undefined;
}

export class Shipment implements IShipment {
    mainBarcode?: string | undefined;
    barcode?: string | undefined;
    shipmentAmount?: string | undefined;
    shipmentCounter?: string | undefined;
    customer?: Customer | undefined;
    productCode?: string | undefined;
    productDescription?: string | undefined;
    reference?: any | undefined;
    deliveryDate?: string | undefined;
    dimension?: Dimension | undefined;
    amount?: Amount | undefined;
    address?: Address[] | undefined;
    event?: Event[] | undefined;
    expectation?: Expectation | undefined;
    productOptions?: ProductOptions | undefined;
    status?: Status | undefined;
    oldStatus?: OldStatu[] | undefined;

    constructor(data?: IShipment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mainBarcode = _data["mainBarcode"];
            this.barcode = _data["barcode"];
            this.shipmentAmount = _data["shipmentAmount"];
            this.shipmentCounter = _data["shipmentCounter"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.productCode = _data["productCode"];
            this.productDescription = _data["productDescription"];
            this.reference = _data["reference"];
            this.deliveryDate = _data["deliveryDate"];
            this.dimension = _data["dimension"] ? Dimension.fromJS(_data["dimension"]) : <any>undefined;
            this.amount = _data["amount"] ? Amount.fromJS(_data["amount"]) : <any>undefined;
            if (Array.isArray(_data["address"])) {
                this.address = [] as any;
                for (let item of _data["address"])
                    this.address!.push(Address.fromJS(item));
            }
            if (Array.isArray(_data["event"])) {
                this.event = [] as any;
                for (let item of _data["event"])
                    this.event!.push(Event.fromJS(item));
            }
            this.expectation = _data["expectation"] ? Expectation.fromJS(_data["expectation"]) : <any>undefined;
            this.productOptions = _data["productOptions"] ? ProductOptions.fromJS(_data["productOptions"]) : <any>undefined;
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : <any>undefined;
            if (Array.isArray(_data["oldStatus"])) {
                this.oldStatus = [] as any;
                for (let item of _data["oldStatus"])
                    this.oldStatus!.push(OldStatu.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Shipment {
        data = typeof data === 'object' ? data : {};
        let result = new Shipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainBarcode"] = this.mainBarcode;
        data["barcode"] = this.barcode;
        data["shipmentAmount"] = this.shipmentAmount;
        data["shipmentCounter"] = this.shipmentCounter;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["productCode"] = this.productCode;
        data["productDescription"] = this.productDescription;
        data["reference"] = this.reference;
        data["deliveryDate"] = this.deliveryDate;
        data["dimension"] = this.dimension ? this.dimension.toJSON() : <any>undefined;
        data["amount"] = this.amount ? this.amount.toJSON() : <any>undefined;
        if (Array.isArray(this.address)) {
            data["address"] = [];
            for (let item of this.address)
                data["address"].push(item.toJSON());
        }
        if (Array.isArray(this.event)) {
            data["event"] = [];
            for (let item of this.event)
                data["event"].push(item.toJSON());
        }
        data["expectation"] = this.expectation ? this.expectation.toJSON() : <any>undefined;
        data["productOptions"] = this.productOptions ? this.productOptions.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (Array.isArray(this.oldStatus)) {
            data["oldStatus"] = [];
            for (let item of this.oldStatus)
                data["oldStatus"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IShipment {
    mainBarcode?: string | undefined;
    barcode?: string | undefined;
    shipmentAmount?: string | undefined;
    shipmentCounter?: string | undefined;
    customer?: Customer | undefined;
    productCode?: string | undefined;
    productDescription?: string | undefined;
    reference?: any | undefined;
    deliveryDate?: string | undefined;
    dimension?: Dimension | undefined;
    amount?: Amount | undefined;
    address?: Address[] | undefined;
    event?: Event[] | undefined;
    expectation?: Expectation | undefined;
    productOptions?: ProductOptions | undefined;
    status?: Status | undefined;
    oldStatus?: OldStatu[] | undefined;
}

export class Customer implements ICustomer {
    customerCode?: string | undefined;
    customerNumber?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerCode = _data["customerCode"];
            this.customerNumber = _data["customerNumber"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode;
        data["customerNumber"] = this.customerNumber;
        data["name"] = this.name;
        return data; 
    }
}

export interface ICustomer {
    customerCode?: string | undefined;
    customerNumber?: string | undefined;
    name?: string | undefined;
}

export class Dimension implements IDimension {
    weight?: string | undefined;
    height?: string | undefined;
    length?: string | undefined;
    width?: string | undefined;
    volume?: string | undefined;

    constructor(data?: IDimension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.length = _data["length"];
            this.width = _data["width"];
            this.volume = _data["volume"];
        }
    }

    static fromJS(data: any): Dimension {
        data = typeof data === 'object' ? data : {};
        let result = new Dimension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["length"] = this.length;
        data["width"] = this.width;
        data["volume"] = this.volume;
        return data; 
    }
}

export interface IDimension {
    weight?: string | undefined;
    height?: string | undefined;
    length?: string | undefined;
    width?: string | undefined;
    volume?: string | undefined;
}

export class Amount implements IAmount {
    remboursBedrag?: string | undefined;
    verzekerdBedrag?: string | undefined;

    constructor(data?: IAmount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.remboursBedrag = _data["remboursBedrag"];
            this.verzekerdBedrag = _data["verzekerdBedrag"];
        }
    }

    static fromJS(data: any): Amount {
        data = typeof data === 'object' ? data : {};
        let result = new Amount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remboursBedrag"] = this.remboursBedrag;
        data["verzekerdBedrag"] = this.verzekerdBedrag;
        return data; 
    }
}

export interface IAmount {
    remboursBedrag?: string | undefined;
    verzekerdBedrag?: string | undefined;
}

export class Address implements IAddress {
    firstName?: any | undefined;
    lastName?: string | undefined;
    companyName?: string | undefined;
    departmentName?: any | undefined;
    countryCode?: any | undefined;
    zipcode?: any | undefined;
    region?: any | undefined;
    district?: any | undefined;
    city?: any | undefined;
    street?: any | undefined;
    houseNumber?: any | undefined;
    building?: any | undefined;
    floor?: any | undefined;
    remark?: any | undefined;
    registrationDate?: any | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.companyName = _data["companyName"];
            this.departmentName = _data["departmentName"];
            this.countryCode = _data["countryCode"];
            this.zipcode = _data["zipcode"];
            this.region = _data["region"];
            this.district = _data["district"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.building = _data["building"];
            this.floor = _data["floor"];
            this.remark = _data["remark"];
            this.registrationDate = _data["registrationDate"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["companyName"] = this.companyName;
        data["departmentName"] = this.departmentName;
        data["countryCode"] = this.countryCode;
        data["zipcode"] = this.zipcode;
        data["region"] = this.region;
        data["district"] = this.district;
        data["city"] = this.city;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["building"] = this.building;
        data["floor"] = this.floor;
        data["remark"] = this.remark;
        data["registrationDate"] = this.registrationDate;
        return data; 
    }
}

export interface IAddress {
    firstName?: any | undefined;
    lastName?: string | undefined;
    companyName?: string | undefined;
    departmentName?: any | undefined;
    countryCode?: any | undefined;
    zipcode?: any | undefined;
    region?: any | undefined;
    district?: any | undefined;
    city?: any | undefined;
    street?: any | undefined;
    houseNumber?: any | undefined;
    building?: any | undefined;
    floor?: any | undefined;
    remark?: any | undefined;
    registrationDate?: any | undefined;
}

export class Event implements IEvent {
    code?: string | undefined;
    description?: string | undefined;
    destinationLocationCode?: string | undefined;
    locationCode?: string | undefined;
    routeCode?: string | undefined;
    routeNumber?: string | undefined;
    timeStamp?: string | undefined;

    constructor(data?: IEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            this.destinationLocationCode = _data["destinationLocationCode"];
            this.locationCode = _data["locationCode"];
            this.routeCode = _data["routeCode"];
            this.routeNumber = _data["routeNumber"];
            this.timeStamp = _data["timeStamp"];
        }
    }

    static fromJS(data: any): Event {
        data = typeof data === 'object' ? data : {};
        let result = new Event();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["destinationLocationCode"] = this.destinationLocationCode;
        data["locationCode"] = this.locationCode;
        data["routeCode"] = this.routeCode;
        data["routeNumber"] = this.routeNumber;
        data["timeStamp"] = this.timeStamp;
        return data; 
    }
}

export interface IEvent {
    code?: string | undefined;
    description?: string | undefined;
    destinationLocationCode?: string | undefined;
    locationCode?: string | undefined;
    routeCode?: string | undefined;
    routeNumber?: string | undefined;
    timeStamp?: string | undefined;
}

export class Expectation implements IExpectation {
    etaFrom?: string | undefined;
    etaTo?: string | undefined;

    constructor(data?: IExpectation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.etaFrom = _data["etaFrom"];
            this.etaTo = _data["etaTo"];
        }
    }

    static fromJS(data: any): Expectation {
        data = typeof data === 'object' ? data : {};
        let result = new Expectation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["etaFrom"] = this.etaFrom;
        data["etaTo"] = this.etaTo;
        return data; 
    }
}

export interface IExpectation {
    etaFrom?: string | undefined;
    etaTo?: string | undefined;
}

export class ProductOptions implements IProductOptions {
    productOption?: ProductOption | undefined;

    constructor(data?: IProductOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productOption = _data["productOption"] ? ProductOption.fromJS(_data["productOption"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ProductOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productOption"] = this.productOption ? this.productOption.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IProductOptions {
    productOption?: ProductOption | undefined;
}

export class ProductOption implements IProductOption {
    optionDescription?: string | undefined;
    optionCode?: string | undefined;
    characteristicDescription?: string | undefined;
    characteristicCode?: string | undefined;

    constructor(data?: IProductOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optionDescription = _data["optionDescription"];
            this.optionCode = _data["optionCode"];
            this.characteristicDescription = _data["characteristicDescription"];
            this.characteristicCode = _data["characteristicCode"];
        }
    }

    static fromJS(data: any): ProductOption {
        data = typeof data === 'object' ? data : {};
        let result = new ProductOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optionDescription"] = this.optionDescription;
        data["optionCode"] = this.optionCode;
        data["characteristicDescription"] = this.characteristicDescription;
        data["characteristicCode"] = this.characteristicCode;
        return data; 
    }
}

export interface IProductOption {
    optionDescription?: string | undefined;
    optionCode?: string | undefined;
    characteristicDescription?: string | undefined;
    characteristicCode?: string | undefined;
}

export class Status implements IStatus {
    timeStamp?: string | undefined;
    statusCode?: string | undefined;
    statusDescription?: string | undefined;
    phaseCode?: string | undefined;
    phaseDescription?: string | undefined;

    constructor(data?: IStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"];
            this.statusCode = _data["statusCode"];
            this.statusDescription = _data["statusDescription"];
            this.phaseCode = _data["phaseCode"];
            this.phaseDescription = _data["phaseDescription"];
        }
    }

    static fromJS(data: any): Status {
        data = typeof data === 'object' ? data : {};
        let result = new Status();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp;
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["phaseCode"] = this.phaseCode;
        data["phaseDescription"] = this.phaseDescription;
        return data; 
    }
}

export interface IStatus {
    timeStamp?: string | undefined;
    statusCode?: string | undefined;
    statusDescription?: string | undefined;
    phaseCode?: string | undefined;
    phaseDescription?: string | undefined;
}

export class OldStatu implements IOldStatu {
    timeStamp?: string | undefined;
    statusCode?: string | undefined;
    statusDescription?: string | undefined;
    phaseCode?: string | undefined;
    phaseDescription?: string | undefined;

    constructor(data?: IOldStatu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"];
            this.statusCode = _data["statusCode"];
            this.statusDescription = _data["statusDescription"];
            this.phaseCode = _data["phaseCode"];
            this.phaseDescription = _data["phaseDescription"];
        }
    }

    static fromJS(data: any): OldStatu {
        data = typeof data === 'object' ? data : {};
        let result = new OldStatu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp;
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["phaseCode"] = this.phaseCode;
        data["phaseDescription"] = this.phaseDescription;
        return data; 
    }
}

export interface IOldStatu {
    timeStamp?: string | undefined;
    statusCode?: string | undefined;
    statusDescription?: string | undefined;
    phaseCode?: string | undefined;
    phaseDescription?: string | undefined;
}

export class CreatePostNlShipmentLableResponse implements ICreatePostNlShipmentLableResponse {
    warnings?: PostNLWarning[] | undefined;
    printCommand?: string | undefined;
    barcode?: string | undefined;

    constructor(data?: ICreatePostNlShipmentLableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(PostNLWarning.fromJS(item));
            }
            this.printCommand = _data["printCommand"];
            this.barcode = _data["barcode"];
        }
    }

    static fromJS(data: any): CreatePostNlShipmentLableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePostNlShipmentLableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        data["printCommand"] = this.printCommand;
        data["barcode"] = this.barcode;
        return data; 
    }
}

export interface ICreatePostNlShipmentLableResponse {
    warnings?: PostNLWarning[] | undefined;
    printCommand?: string | undefined;
    barcode?: string | undefined;
}

export class PostNLWarning implements IPostNLWarning {
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPostNLWarning) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PostNLWarning {
        data = typeof data === 'object' ? data : {};
        let result = new PostNLWarning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data; 
    }
}

export interface IPostNLWarning {
    code?: string | undefined;
    description?: string | undefined;
}

export class CreatePostNlShipmentLableRequest implements ICreatePostNlShipmentLableRequest {
    straat?: string | undefined;
    huisnummer?: string | undefined;
    huisnummerToevoeging?: string | undefined;
    postcode?: string | undefined;
    plaats?: string | undefined;
    adresToevoeging?: string | undefined;
    klantNaam?: string | undefined;
    email?: string | undefined;
    telefoon?: string | undefined;
    gewicht?: string | undefined;
    pakbonId?: number | undefined;

    constructor(data?: ICreatePostNlShipmentLableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.straat = _data["straat"];
            this.huisnummer = _data["huisnummer"];
            this.huisnummerToevoeging = _data["huisnummerToevoeging"];
            this.postcode = _data["postcode"];
            this.plaats = _data["plaats"];
            this.adresToevoeging = _data["adresToevoeging"];
            this.klantNaam = _data["klantNaam"];
            this.email = _data["email"];
            this.telefoon = _data["telefoon"];
            this.gewicht = _data["gewicht"];
            this.pakbonId = _data["pakbonId"];
        }
    }

    static fromJS(data: any): CreatePostNlShipmentLableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePostNlShipmentLableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["straat"] = this.straat;
        data["huisnummer"] = this.huisnummer;
        data["huisnummerToevoeging"] = this.huisnummerToevoeging;
        data["postcode"] = this.postcode;
        data["plaats"] = this.plaats;
        data["adresToevoeging"] = this.adresToevoeging;
        data["klantNaam"] = this.klantNaam;
        data["email"] = this.email;
        data["telefoon"] = this.telefoon;
        data["gewicht"] = this.gewicht;
        data["pakbonId"] = this.pakbonId;
        return data; 
    }
}

export interface ICreatePostNlShipmentLableRequest {
    straat?: string | undefined;
    huisnummer?: string | undefined;
    huisnummerToevoeging?: string | undefined;
    postcode?: string | undefined;
    plaats?: string | undefined;
    adresToevoeging?: string | undefined;
    klantNaam?: string | undefined;
    email?: string | undefined;
    telefoon?: string | undefined;
    gewicht?: string | undefined;
    pakbonId?: number | undefined;
}

export class CreateMyParcelShipmentLabelResponse implements ICreateMyParcelShipmentLabelResponse {
    shipmentId?: number;
    barcode?: string | undefined;
    zplCommand?: string | undefined;

    constructor(data?: ICreateMyParcelShipmentLabelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipmentId = _data["shipmentId"];
            this.barcode = _data["barcode"];
            this.zplCommand = _data["zplCommand"];
        }
    }

    static fromJS(data: any): CreateMyParcelShipmentLabelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMyParcelShipmentLabelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipmentId"] = this.shipmentId;
        data["barcode"] = this.barcode;
        data["zplCommand"] = this.zplCommand;
        return data; 
    }
}

export interface ICreateMyParcelShipmentLabelResponse {
    shipmentId?: number;
    barcode?: string | undefined;
    zplCommand?: string | undefined;
}

export class CreateMyParcelShipmentLabelRequest implements ICreateMyParcelShipmentLabelRequest {
    straat?: string | undefined;
    huisnummer?: string | undefined;
    huisnummerToevoeging?: string | undefined;
    postcode?: string | undefined;
    plaats?: string | undefined;
    adresToevoeging?: string | undefined;
    klantNaam?: string | undefined;
    email?: string | undefined;
    telefoon?: string | undefined;
    gewicht?: string | undefined;
    pakbonId?: number | undefined;

    constructor(data?: ICreateMyParcelShipmentLabelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.straat = _data["straat"];
            this.huisnummer = _data["huisnummer"];
            this.huisnummerToevoeging = _data["huisnummerToevoeging"];
            this.postcode = _data["postcode"];
            this.plaats = _data["plaats"];
            this.adresToevoeging = _data["adresToevoeging"];
            this.klantNaam = _data["klantNaam"];
            this.email = _data["email"];
            this.telefoon = _data["telefoon"];
            this.gewicht = _data["gewicht"];
            this.pakbonId = _data["pakbonId"];
        }
    }

    static fromJS(data: any): CreateMyParcelShipmentLabelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMyParcelShipmentLabelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["straat"] = this.straat;
        data["huisnummer"] = this.huisnummer;
        data["huisnummerToevoeging"] = this.huisnummerToevoeging;
        data["postcode"] = this.postcode;
        data["plaats"] = this.plaats;
        data["adresToevoeging"] = this.adresToevoeging;
        data["klantNaam"] = this.klantNaam;
        data["email"] = this.email;
        data["telefoon"] = this.telefoon;
        data["gewicht"] = this.gewicht;
        data["pakbonId"] = this.pakbonId;
        return data; 
    }
}

export interface ICreateMyParcelShipmentLabelRequest {
    straat?: string | undefined;
    huisnummer?: string | undefined;
    huisnummerToevoeging?: string | undefined;
    postcode?: string | undefined;
    plaats?: string | undefined;
    adresToevoeging?: string | undefined;
    klantNaam?: string | undefined;
    email?: string | undefined;
    telefoon?: string | undefined;
    gewicht?: string | undefined;
    pakbonId?: number | undefined;
}

export class GetMyParcelLabelResponse implements IGetMyParcelLabelResponse {
    zplCommand?: string | undefined;

    constructor(data?: IGetMyParcelLabelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zplCommand = _data["zplCommand"];
        }
    }

    static fromJS(data: any): GetMyParcelLabelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyParcelLabelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zplCommand"] = this.zplCommand;
        return data; 
    }
}

export interface IGetMyParcelLabelResponse {
    zplCommand?: string | undefined;
}

export class ImportBuldAddressResponse implements IImportBuldAddressResponse {
    buldAddress?: BulkAddress[] | undefined;

    constructor(data?: IImportBuldAddressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buldAddress"])) {
                this.buldAddress = [] as any;
                for (let item of _data["buldAddress"])
                    this.buldAddress!.push(BulkAddress.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportBuldAddressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportBuldAddressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buldAddress)) {
            data["buldAddress"] = [];
            for (let item of this.buldAddress)
                data["buldAddress"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IImportBuldAddressResponse {
    buldAddress?: BulkAddress[] | undefined;
}

export class BulkAddress implements IBulkAddress {
    name?: string | undefined;
    street?: string | undefined;
    housenumber?: string | undefined;
    housenumberAddition?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;

    constructor(data?: IBulkAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.street = _data["street"];
            this.housenumber = _data["housenumber"];
            this.housenumberAddition = _data["housenumberAddition"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): BulkAddress {
        data = typeof data === 'object' ? data : {};
        let result = new BulkAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["street"] = this.street;
        data["housenumber"] = this.housenumber;
        data["housenumberAddition"] = this.housenumberAddition;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        return data; 
    }
}

export interface IBulkAddress {
    name?: string | undefined;
    street?: string | undefined;
    housenumber?: string | undefined;
    housenumberAddition?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
}

export class CreateBulkShipmentsRequest implements ICreateBulkShipmentsRequest {
    shipmentAddresses?: BulkAddress[] | undefined;
    description?: string | undefined;
    defaultEmail?: string | undefined;
    weight?: string | undefined;
    phone?: string | undefined;

    constructor(data?: ICreateBulkShipmentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shipmentAddresses"])) {
                this.shipmentAddresses = [] as any;
                for (let item of _data["shipmentAddresses"])
                    this.shipmentAddresses!.push(BulkAddress.fromJS(item));
            }
            this.description = _data["description"];
            this.defaultEmail = _data["defaultEmail"];
            this.weight = _data["weight"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): CreateBulkShipmentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBulkShipmentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shipmentAddresses)) {
            data["shipmentAddresses"] = [];
            for (let item of this.shipmentAddresses)
                data["shipmentAddresses"].push(item.toJSON());
        }
        data["description"] = this.description;
        data["defaultEmail"] = this.defaultEmail;
        data["weight"] = this.weight;
        data["phone"] = this.phone;
        return data; 
    }
}

export interface ICreateBulkShipmentsRequest {
    shipmentAddresses?: BulkAddress[] | undefined;
    description?: string | undefined;
    defaultEmail?: string | undefined;
    weight?: string | undefined;
    phone?: string | undefined;
}

export class VerzendBulk implements IVerzendBulk {
    id?: number;
    description?: string | undefined;
    email?: string | undefined;
    phonenumber?: string | undefined;
    weight?: string | undefined;
    verzendLabels?: Verzendlabel[] | undefined;

    constructor(data?: IVerzendBulk) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.email = _data["email"];
            this.phonenumber = _data["phonenumber"];
            this.weight = _data["weight"];
            if (Array.isArray(_data["verzendLabels"])) {
                this.verzendLabels = [] as any;
                for (let item of _data["verzendLabels"])
                    this.verzendLabels!.push(Verzendlabel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VerzendBulk {
        data = typeof data === 'object' ? data : {};
        let result = new VerzendBulk();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["email"] = this.email;
        data["phonenumber"] = this.phonenumber;
        data["weight"] = this.weight;
        if (Array.isArray(this.verzendLabels)) {
            data["verzendLabels"] = [];
            for (let item of this.verzendLabels)
                data["verzendLabels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IVerzendBulk {
    id?: number;
    description?: string | undefined;
    email?: string | undefined;
    phonenumber?: string | undefined;
    weight?: string | undefined;
    verzendLabels?: Verzendlabel[] | undefined;
}

export class AddToStockDto implements IAddToStockDto {
    batch?: Batch | undefined;
    product?: Product | undefined;
    gewicht?: number;

    constructor(data?: IAddToStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batch = _data["batch"] ? Batch.fromJS(_data["batch"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.gewicht = _data["gewicht"];
        }
    }

    static fromJS(data: any): AddToStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddToStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batch"] = this.batch ? this.batch.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["gewicht"] = this.gewicht;
        return data; 
    }
}

export interface IAddToStockDto {
    batch?: Batch | undefined;
    product?: Product | undefined;
    gewicht?: number;
}

export class PackingSlipStockDto implements IPackingSlipStockDto {
    batchId?: number;
    pakbonRegel?: PakbonRegel | undefined;

    constructor(data?: IPackingSlipStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            this.pakbonRegel = _data["pakbonRegel"] ? PakbonRegel.fromJS(_data["pakbonRegel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PackingSlipStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackingSlipStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        data["pakbonRegel"] = this.pakbonRegel ? this.pakbonRegel.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPackingSlipStockDto {
    batchId?: number;
    pakbonRegel?: PakbonRegel | undefined;
}

export class BackgroundTask implements IBackgroundTask {
    id?: string;
    userId?: number | undefined;
    name?: string | undefined;
    count?: number | undefined;
    totalCount?: number | undefined;
    createdon?: Date;
    finishedOn?: Date | undefined;
    status?: TaskStatus;
    rows?: BackgroundTaskItem[] | undefined;

    constructor(data?: IBackgroundTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.count = _data["count"];
            this.totalCount = _data["totalCount"];
            this.createdon = _data["createdon"] ? new Date(_data["createdon"].toString()) : <any>undefined;
            this.finishedOn = _data["finishedOn"] ? new Date(_data["finishedOn"].toString()) : <any>undefined;
            this.status = _data["status"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(BackgroundTaskItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BackgroundTask {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["count"] = this.count;
        data["totalCount"] = this.totalCount;
        data["createdon"] = this.createdon ? this.createdon.toISOString() : <any>undefined;
        data["finishedOn"] = this.finishedOn ? this.finishedOn.toISOString() : <any>undefined;
        data["status"] = this.status;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBackgroundTask {
    id?: string;
    userId?: number | undefined;
    name?: string | undefined;
    count?: number | undefined;
    totalCount?: number | undefined;
    createdon?: Date;
    finishedOn?: Date | undefined;
    status?: TaskStatus;
    rows?: BackgroundTaskItem[] | undefined;
}

export enum TaskStatus {
    InProgress = 0,
    Done = 1,
    Failed = 2,
    Canceled = 3,
}

export class BackgroundTaskItem implements IBackgroundTaskItem {
    id?: string;
    backgroundTaskId?: string;
    description?: string | undefined;
    data?: { [key: string]: string; } | undefined;
    state?: BackgroundTaskRowState;

    constructor(data?: IBackgroundTaskItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.backgroundTaskId = _data["backgroundTaskId"];
            this.description = _data["description"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): BackgroundTaskItem {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundTaskItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["backgroundTaskId"] = this.backgroundTaskId;
        data["description"] = this.description;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = this.data[key];
            }
        }
        data["state"] = this.state;
        return data; 
    }
}

export interface IBackgroundTaskItem {
    id?: string;
    backgroundTaskId?: string;
    description?: string | undefined;
    data?: { [key: string]: string; } | undefined;
    state?: BackgroundTaskRowState;
}

export enum BackgroundTaskRowState {
    Success = 0,
    Info = 1,
    Error = 2,
    Warn = 3,
}

export class AddUserRequest implements IAddUserRequest {
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    application?: Application;
    role?: UserRole;
    customerId?: number | undefined;
    redirectUrl?: string | undefined;

    constructor(data?: IAddUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.application = _data["application"];
            this.role = _data["role"];
            this.customerId = _data["customerId"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): AddUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["application"] = this.application;
        data["role"] = this.role;
        data["customerId"] = this.customerId;
        data["redirectUrl"] = this.redirectUrl;
        return data; 
    }
}

export interface IAddUserRequest {
    username?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    application?: Application;
    role?: UserRole;
    customerId?: number | undefined;
    redirectUrl?: string | undefined;
}

export class UpdateUserRequset implements IUpdateUserRequset {
    id?: number;
    username?: string | undefined;
    email?: string | undefined;
    imageUrl?: string | undefined;
    fullName?: string | undefined;
    application?: Application;
    role?: UserRole;

    constructor(data?: IUpdateUserRequset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.imageUrl = _data["imageUrl"];
            this.fullName = _data["fullName"];
            this.application = _data["application"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): UpdateUserRequset {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRequset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["email"] = this.email;
        data["imageUrl"] = this.imageUrl;
        data["fullName"] = this.fullName;
        data["application"] = this.application;
        data["role"] = this.role;
        return data; 
    }
}

export interface IUpdateUserRequset {
    id?: number;
    username?: string | undefined;
    email?: string | undefined;
    imageUrl?: string | undefined;
    fullName?: string | undefined;
    application?: Application;
    role?: UserRole;
}

export class ActivateUserRequest implements IActivateUserRequest {
    userId?: number;

    constructor(data?: IActivateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ActivateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IActivateUserRequest {
    userId?: number;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    newPassword?: string | undefined;
    oldPassword?: string | undefined;
    email?: string | undefined;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
            this.oldPassword = _data["oldPassword"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["oldPassword"] = this.oldPassword;
        data["email"] = this.email;
        return data; 
    }
}

export interface IChangePasswordRequest {
    newPassword?: string | undefined;
    oldPassword?: string | undefined;
    email?: string | undefined;
}

export class RequestNewPasswordRequest implements IRequestNewPasswordRequest {
    emailAddress?: string | undefined;
    returnUrl?: string | undefined;

    constructor(data?: IRequestNewPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.returnUrl = _data["returnUrl"];
        }
    }

    static fromJS(data: any): RequestNewPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequestNewPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["returnUrl"] = this.returnUrl;
        return data; 
    }
}

export interface IRequestNewPasswordRequest {
    emailAddress?: string | undefined;
    returnUrl?: string | undefined;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
    password?: string | undefined;
    resetKey?: string | undefined;

    constructor(data?: IResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.resetKey = _data["resetKey"];
        }
    }

    static fromJS(data: any): ResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["resetKey"] = this.resetKey;
        return data; 
    }
}

export interface IResetPasswordRequest {
    password?: string | undefined;
    resetKey?: string | undefined;
}

export class GetAddressRespone implements IGetAddressRespone {
    street?: string | undefined;
    city?: string | undefined;
    postcode?: string | undefined;
    house_number?: string | undefined;

    constructor(data?: IGetAddressRespone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.city = _data["city"];
            this.postcode = _data["postcode"];
            this.house_number = _data["house_number"];
        }
    }

    static fromJS(data: any): GetAddressRespone {
        data = typeof data === 'object' ? data : {};
        let result = new GetAddressRespone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["city"] = this.city;
        data["postcode"] = this.postcode;
        data["house_number"] = this.house_number;
        return data; 
    }
}

export interface IGetAddressRespone {
    street?: string | undefined;
    city?: string | undefined;
    postcode?: string | undefined;
    house_number?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}